import React, { useEffect, useRef, useState ,useLayoutEffect  } from "react";

import { Link, useLocation ,} from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { FaBars, FaTimes } from "react-icons/fa"; // Import icons for open/close
import { FaSearch } from 'react-icons/fa';                          
import "../ComponentsCss/Menubar.css";
import { useNavigate } from "react-router-dom";
import ChevronUpIcon from "../Assets/down-chevron_12514381.png"; // Adjust the path as per your file structure
import chevronup from "../Assets/chevronup.png";
import chevrondown from "../Assets/chevrondown.png";
import { FaArrowRight } from 'react-icons/fa';
import { FaArrowLeft } from 'react-icons/fa';
import { FaArrowLeftLong } from 'react-icons/fa6';
import chevronright from "../Assets/chevronright.png"
import chevdown from "../Assets/Chevdown.png"
import { PiArrowLeftBold } from "react-icons/pi";
import DashboardLight from "../Assets/DashboardLight.jpg" // active icon
import BeingAssesmentLight from "../Assets/BeingAssesmentLight.jpg" //active icon 
import APILight from "../Assets/APILight.jpg"
import AssetLight from "../Assets/AssetLight.jpg"
import ISOLight from "../Assets/ISOLight.jpg"
import PCILight from "../Assets/PCILight.jpg"
import AWSLight from "../Assets/AWSLight.jpg"
import AzureLight from "../Assets/AzureLight.png"
import CloudLight from "../Assets/CloudLight.png"
import wirelessLight from "../Assets/wirelessLight.png"
import blockLight from "../Assets/blockLight.png"
import cislight from "../Assets/CISLight.png"
import genlight from "../Assets/genLight.png"
import mlight from "../Assets/m365Light.png"
import devlight from "../Assets/devopsLight.png"
import operationlight from "../Assets/operationLight.png"
import datalight from "../Assets/databaseLight.png"
import privacylight from "../Assets/privacyLight.png"
import locationlight from "../Assets/locationLight.png"
import OTIOT from "../Assets/OTIOT.png"
import network from "../Assets/NetworkInfrastructure.png" 
import hypervisor from "../Assets/PrivateCloudHypervisor.png"
import red from "../Assets/RED.png"
import eu from "../Assets/EU.png";
import india from "../Assets/India.png";
import ireland from "../Assets/Ireland.png";
import uk from "../Assets/UK.png"; 
import usa from "../Assets/USA.png";
import logo from "../Assets/SUSAN logo White.png";
import { GoalIcon } from "lucide-react";
import NISTSP63 from "../Assets/NIST SP 800-63 (IAM).png"
import SOC2 from "../Assets/SOC2.svg"
import NISTSP53 from "../Assets/NIST SP 800-53.png"
import NISTPrivacyFramework from "../Assets/NIST Privacy Framework.png"
import SupplyChain from "../Assets/Supply Chain Risk.png"
import overlap from "../Assets/unified control mapping.png"  
import BackgroundFooter from "./BackgroundFooter";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import SecurityModel from "./SecurityModel";
import compliance from "../Assets/Compliance.png"
import google from "../Assets/Cloud1.png"
import tech from "../Assets/TechRisk.png"
import { FaRegStar, FaStar } from "react-icons/fa";
import access from "../Assets/quick.png";
import pin from "../Assets/pin1.png";
import fillpin from "../Assets/fillpin1.png";
import traingassessment from "../Assets/training.png"
import oraclecloud from "../Assets/OracleCloud.png";
import securityscan from "../Assets/dastIcons.png";

const Menubar = ({ isCollapsed, onToggle, moduleProgress }) => {

  

  // const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    
  //   const sidebarState = localStorage.getItem("sidebarOpenFromHomepage");
  //   if (sidebarState === "true" && window.innerWidth <= 768) {
  //     return false; // Open sidebar if in mobile mode
  //   }
  //   return JSON.parse(localStorage.getItem("isSidebarCollapsed")) || false;
  // });



  // Default collapsed = true unless an explicit persisted value exists
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    // Optional: retain persisted value if present, otherwise default to true (collapsed)
    const persisted = localStorage.getItem("isSidebarCollapsed");
    return persisted !== null ? JSON.parse(persisted) : true;
  });





 // Ensure the sidebar is closed on first load/login/refresh
  // useEffect(() => {
  //   try {
  //     localStorage.removeItem("sidebarOpenFromHomepage");
  //     sessionStorage.removeItem("suppressAutoOpenOnce");

  //     setIsSidebarCollapsed(true);
  //     localStorage.setItem("isSidebarCollapsed", "true");

  //     if (!isCollapsed && typeof onToggle === "function") {
  //       onToggle();
  //     }
  //   } catch {
  //   }
  // }, []); 



















const suppressAutoOpen =
  typeof window !== "undefined" &&
  sessionStorage.getItem("suppressAutoOpenOnce") === "1";






// Pinned modules: persisted by path
const [pinned, setPinned] = useState(() => {
  try {
    return JSON.parse(localStorage.getItem("pinnedModules") || "[]");
  } catch {
    return [];
  }
});

useEffect(() => {
  localStorage.setItem("pinnedModules", JSON.stringify(pinned));
}, [pinned]);

const isPinned = (path) => pinned.includes(path);

const togglePin = (path) => {
  setPinned((prev) => (prev.includes(path) ? prev.filter(p => p !== path) : [...prev, path]));
};

// Find module metadata by path to render icon/label in pinned list
const findModuleByPath = (modules, targetPath) => {
  for (const m of modules) {
    if (m.path === targetPath) return m;
    if (m.submodules) {
      const found = findModuleByPath(m.submodules, targetPath);
      if (found) return found;
    }
  }
  return null;
};

// Reusable pin button
const renderPinButton = (path) => {
  if (!path) return null; // only pin navigable items
  const pinnedNow = isPinned(path);
  return (
    <button
      className={`pin-button ${pinnedNow ? "pinned" : ""}`}
      title={pinnedNow ? "Unpin" : "Pin"}
      aria-label={pinnedNow ? "Unpin" : "Pin"}
      onClick={(e) => {

        e.stopPropagation();
        togglePin(path);
      }}
    >
      {/* {pinnedNow ? pin : fillpin} */}
      <img
  src={pinnedNow ? fillpin : pin}
  alt={pinnedNow ? "Unpin" : "Pin"}
  className="pin-icon"
/>

    </button>
  );
};























  useEffect(() => {
    if (window.innerWidth <= 768) {
      localStorage.removeItem("sidebarOpenFromHomepage"); // Clear after first load
    }
  }, []);

  const navigate = useNavigate();
  const location = useLocation();











  // ---- outside component (file top-level) ----
const ISO_SUBPATHS = [
  "/annexacontrolsoverview",
  "/organizational",
  "/people",
  "/physical",
  "/technological",
];

const COMPLIANCES_SUBPATHS = [
  "/cissecurity",
  ...ISO_SUBPATHS,
  "/soc2",
  "/nistsp80053",
  "/nistsp80063iam",
  "/pcidsscompliance",
  "/otiotsecurity",
  "/red",
  "/operationalresilience",
];

const TECH_SUBPATHS = [
  "/genai",
  "/applicationdatabasesecurity",
  "/devsecops",
  "/privatecloudhypervisor",
  "/blockchainsecurity",
  "/wirelesssecurity",
];
// 🔹 Network Infrastructure section
const NETWORK_SUBPATHS = [
  "/networksecurity",
  "/cisco",
  "/juniper",
  "/fortinet",
  "/paloalto",
  "/checkpoint",
];

// 🔹 AWS Cloud section
const AWS_SUBPATHS = [
  "/iam",
  "/detection",
  "/infrastructureprotection",
  "/dataprotection",
  "/inscidentresponseandautomation",
];

// 🔹 Azure Cloud section
const AZURE_SUBPATHS = [
  "/iamazurecloudsecurity",
  "/detectionazure",
  "/infrastructureprotectionazure",
  "/dataprotectionazure",
  "/aiazure",
];

// 🔹 Google Cloud section
const GOOGLE_SUBPATHS = [
  "/iamgoogle",
  "/detectiongoogle",
  "/infrastructureprotectiongoogle",
  "/dataprotectiongoogle",
  "/aigoogle",
];

// 🔹 Microsoft 365 section
const M365_SUBPATHS = [
  "/iamandmfa",
  "/useradministration",
  "/intunesuserenrollmentandmanagement",
  "/grouppolicies",
  "/hybridconnect",
  "/onpremtocloudmigration",
  "/windowsuserbitlockerencryption",
  "/windowsuserfirewallmanagement",
  "/windowsuserpatching",
  "/ssoandenterpriseapplications",
  "/sentinel",
];

// 🔹 Privacy / Data Protection Compliance section
const PRIVACY_SUBPATHS = [
  "/dpdpmodule",
  "/ccpamodule",
   
  "/gdpr",
  "/uaemodule",
  "/pdpl",
  "/data&riskmgmt",
  "/legalCompliance",
  "/privacyengineering",
  "/privacyframework",
  "/nistprivacyframework",
];

// 🔹 Supply Chain Risk section
const SUPPLYCHAIN_SUBPATHS = [
  "/nist",
  "/ncsc",
  "/certin",
  "/nis2",
];

const markKeepOpenOnNextRoute = (path) => {
  const keep = {};

  // ✅ detect if click came from Quick Access
  const fromQuickAccess = sessionStorage.getItem("fromQuickAccess") === "1";

  if (fromQuickAccess) {
    // keep Quick Access open only — ignore auto-open for others
    keep.openSection = "quickaccess";
  } else {
    // Normal behaviour for direct sidebar clicks
    if (COMPLIANCES_SUBPATHS.includes(path)) {
      keep.openSection = "compliances";
    }
    if (ISO_SUBPATHS.includes(path)) {
      keep.openISOSection = "iso27001";
    }
    if (RISK_ALL_SUBPATHS.includes(path)) {
      keep.openSection = "riskAssessment";
    }
    if (RISK_UCM_SUBPATHS.includes(path)) {
      keep.openSection = "riskAssessment"; // keep parent
      keep.openSubSection = "unifiedControlMapping";
    }
    if (TECH_SUBPATHS.includes(path)) {
      keep.openSection = "Technology&EmergingRisks";
    }
  }

  sessionStorage.setItem("navKeepOpen", JSON.stringify(keep));
  sessionStorage.removeItem("fromQuickAccess"); // reset flag
};



const keep = (() => {
  try { return JSON.parse(sessionStorage.getItem("navKeepOpen") || "{}"); }
  catch { return {}; }
})();












const RISK_PARENT_SUBPATHS = ["/overview", "/assetinventory"];
const RISK_UCM_SUBPATHS = ["/securitycontrols", "/privacycontrols"];
const RISK_ALL_SUBPATHS = [...RISK_PARENT_SUBPATHS, ...RISK_UCM_SUBPATHS];


  const [openSection, setOpenSection] = useState(() => {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  return (
    keep.openSection ||
    (COMPLIANCES_SUBPATHS.includes(path) && "compliances") ||
    (RISK_ALL_SUBPATHS.includes(path) && "riskAssessment") ||
      (TECH_SUBPATHS.includes(path) && "Technology&EmergingRisks") ||

    localStorage.getItem("openSection") ||
    null
  );
});




  const [openResilienceSections, setOpenResilienceSections] = useState(() => {
    return JSON.parse(localStorage.getItem("openResilienceSections")) || {};
  });

 

// ✅ Function to Save Scroll Position
const saveSidebarScroll = () => {
  const sidebar = document.querySelector(".sidebar");
  if (sidebar) {
    localStorage.setItem("sidebarScrollPosition", sidebar.scrollTop);
   
  }
};

// ✅ Restore Scroll Position when Sidebar Mounts
useEffect(() => {
  const sidebar = document.querySelector(".sidebar");
  const savedScroll = localStorage.getItem("sidebarScrollPosition");
  if (sidebar && savedScroll) {
    sidebar.scrollTo(0, parseInt(savedScroll, 10));
   
  }
}, []);









const userToggledTechRef = useRef(false);

  const isActive = (path) => location.pathname === path;


  

const toggleSection = (section) => {
  const next = openSection === section ? null : section;
  setOpenSection(next);
  localStorage.setItem("openSection", next || "");
  if (section === "compliances") userToggledCompliancesRef.current = true;
  if (section === "riskAssessment") userToggledRiskRef.current = true;
  if (section === "Technology&EmergingRisks") userToggledTechRef.current = true; // NEW

};

  const toggleResilienceSection = (section) => {
    setOpenResilienceSections((prevSections) => {
      const updatedSections = {};
      
      // If the clicked section is already open, close it; otherwise, open it and close others
      if (!prevSections[section]) {
        updatedSections[section] = true;
      }
  
      localStorage.setItem("openResilienceSections", JSON.stringify(updatedSections));
      return updatedSections;
    });
  };
 

  // All country → laws mapping
const laws = {
  eu: [
    { name: "DORA" },
    { name: "CRA" },
    { name: "NIS2" },
    { name: "EU AI Act" },
  ],
  india: [
    { name: "CSCRF by SEBI" },
    {name:"CSCRF Checklist"},
  ],
  ireland: [
    { name: "National Cyber Security Bill" },
  ],
  uk: [
    { name: "Cyber Security and Resilience Bill" },
    { name: "GovAssure Program" },
    { name: "Incident Reporting" },
    { name: "Third-Party Infrastructure" },
    { name: "Regulatory Engagement" },
    { name: "Encryption & ICO Readiness" },
    { name: "Quantum-Resilient Security" },
    { name: "PECR Compliance" },
    { name: "Telecom Security Act" },
    { name: "NCSC CAF" },
    { name: "PSN" },
    { name: "PS21/3" },
   {name:"Cyber Essential"}

  ],
  usa: [
    { name: "CIRCIA" },
    { name: "Upcoming AI Executive Orders" },
    { name: "HIPAA" },
     { name: "SOX Compliance" },
     {name : "ICFR"}
  ],
};



  // Recursive render function for laws
const renderLaws = (laws, parentKey) => (
  <ul className="sub-sub-menu resilience-sub-submenu">
    {laws.map((law) => (
      <React.Fragment key={law.name}>
        <li
          className={`resilience-law-item ${
            isActive(`/${law.name.toLowerCase().replace(/\s+/g, "")}`)
              ? "active"
              : ""
          }`}
          onClick={(e) => {
            e.stopPropagation();
            if (law.submodules) {
              toggleResilienceSection(`law-${law.name.toLowerCase()}`);
            } else {
              handleSubmenuClick(
                `/${law.name.toLowerCase().replace(/\s+/g, "")}`
              );
            }
          }}
        >
          <span>{law.name}</span>

          {/* ✅ ONLY CHILD LAWS GET PIN */}
          {!law.submodules &&
            renderPinButton(
              `/${law.name.toLowerCase().replace(/\s+/g, "")}`
            )}
        </li>

        {/* If law has nested submodules */}
        {law.submodules &&
          openResilienceSections[`law-${law.name.toLowerCase()}`] &&
          renderLaws(law.submodules, law.name)}
      </React.Fragment>
    ))}
  </ul>
);


  
 const handleSubmenuClick = (path) => {
  
  
  markKeepOpenOnNextRoute(path);

    saveSidebarScroll(); // Save scroll position before navigation
   if (window.innerWidth <= 768) {
  onToggle(); 
  setIsSidebarCollapsed(prev => !prev);

  // ✅ collapse के साथ state reset
  setOpenSection(null);
  setOpenSubSection(null);
  setOpenISOSection(null);
  localStorage.removeItem("openSection");
  localStorage.removeItem("openRiskSubSection");
  localStorage.removeItem("openISOSection");
    navigate(path);
}



    // Define the paths that should reset the sidebar state
  const resetSidebarPaths = [
    "/overview",
    "/genai",
    "/blockchainsecurity",
    "/wirelesssecurity",
    "/securitymodel",
    "/actionplan",
    "/applicationdatabasesecurity",
    "/siemintegration",
    "/assetinventory",
    "/",
    "/cissecurity",
    "/pcidSScompliance",
    "/otiotsecurity",
    "/ies62443nist",
    "/devsecops",
    "/incidentresponse",
    "/operationalresilience",
    "/privatecloudhypervisor"
  ];

  if (resetSidebarPaths.includes(path)) {
    localStorage.removeItem("openSection"); // ✅ Clears from localStorage
    setOpenSection(null); // ✅ Updates state to close current section
  }
 
    
    setTimeout(() => {
      navigate(path); // Programmatically navigate after sidebar collapse
    }, 
    ); // Ensure `onToggle` completes before navigation
  };


  // console.log("Sidebar collapsed?", isCollapsed);
  const [searchTerm, setSearchTerm] = useState("");

//   toggleSection = (sectionName) => {
//   setOpenSection((prev) => (prev === sectionName ? null : sectionName));
// };

const userToggledCompliancesRef = useRef(false);
const userToggledRiskRef = useRef(false);
const userToggledRiskUCMRef = useRef(false);

// Previous path

// Previous path track


// add near other state declarations (e.g. openSection, openResilienceSections ...)
const [openSubSection, setOpenSubSection] = useState(() => {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  return (
    keep.openSubSection ||
    (RISK_UCM_SUBPATHS.includes(path) && "unifiedControlMapping") ||
    localStorage.getItem("openRiskSubSection") ||
    null
  );
});

const toggleSubSection = (section) => {
  const next = openSubSection === section ? null : section;
  setOpenSubSection(next);
  localStorage.setItem("openRiskSubSection", next || "");
  if (section === "unifiedControlMapping") userToggledRiskUCMRef.current = true;
};

// Ensure nested sub-section closes if parent closes
useEffect(() => {
  if (openSection !== "riskAssessment") {
    setOpenSubSection(null);
    localStorage.removeItem("openSubSection");
  }
}, [openSection]);


// Risk Assessment के लिये आपने openSubSection बनाया था
// अब ISO27001 के लिये भी एक बना लें:
const [openISOSection, setOpenISOSection] = useState(() => {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  return (
    keep.openISOSection ||
    (ISO_SUBPATHS.includes(path) && "iso27001") ||
    localStorage.getItem("openISOSection") ||
    null
  );
});

const userToggledISORef = useRef(false);
const prevPathRef = useRef(location.pathname);


const toggleISOSection = (section) => {
  const next = openISOSection === section ? null : section;
  setOpenISOSection(next);
  localStorage.setItem("openISOSection", next || "");
  if (section === "iso27001") userToggledISORef.current = true;
};


const [openCloudParent, setOpenCloudParent] = useState(null);
const toggleCloudParent = (key) =>
  setOpenCloudParent(openCloudParent === key ? null : key);


const [openTechRisks, setOpenTechRisks] = useState(null);
const toggleTechRisks = () =>
  setOpenTechRisks(openTechRisks === "tech" ? null : "tech");

// Quick Access parent expand/collapse state
// Quick Access parent expand/collapse state (persisted)
const [quickAccessOpen, setQuickAccessOpen] = useState(() => {
  try {
    return JSON.parse(localStorage.getItem('quickAccessOpen') || '{}');
  } catch {
    return {};
  }
});

const toggleQuickAccessOpen = (path) => {
  setQuickAccessOpen((prev) => {
    const next = { ...prev, [path]: !prev[path] };
    try {
      localStorage.setItem('quickAccessOpen', JSON.stringify(next));
    } catch {}
    return next;
  });
};


// helper (put near other small helpers)
const keepQuickAccessOpenOnce = () => {
  // tell mount logic to keep 'quickaccess' open on next route
  sessionStorage.setItem(
    'navKeepOpen',
    JSON.stringify({ openSection: 'quickaccess' })
  );
  // also skip any auto-open overrides once
  sessionStorage.setItem('suppressAutoOpenOnce', 'true');
};


useLayoutEffect(() => {

  
  
  const suppress = sessionStorage.getItem("suppressAutoOpenOnce") === "true";
  if (suppress) {
    sessionStorage.removeItem("suppressAutoOpenOnce");
    // Optional: current state closed hi rahe
    return; // skip the auto-open section below
  }
  const isISOPath = (p) => ISO_SUBPATHS.includes(p);
  const isCompliancesPath = (p) => COMPLIANCES_SUBPATHS.includes(p);
  const isRiskPath = (p) => RISK_ALL_SUBPATHS.includes(p);
  const isRiskUCMPath = (p) => RISK_UCM_SUBPATHS.includes(p);
  if (sessionStorage.getItem("navKeepOpen")) {
    sessionStorage.removeItem("navKeepOpen");
  }

  const prev = prevPathRef.current;
  const now = location.pathname;
  const isTechPath = (p) => TECH_SUBPATHS.includes(p);


  const cameFromOutsideTech = !isTechPath(prev) && isTechPath(now);
  if (cameFromOutsideTech) userToggledTechRef.current = false;

  const cameFromOutsideCompliances = !isCompliancesPath(prev) && isCompliancesPath(now);
  const cameFromOutsideISO = !isISOPath(prev) && isISOPath(now);
  const cameFromOutsideRisk = !isRiskPath(prev) && isRiskPath(now);
  const cameFromOutsideRiskUCM = !isRiskUCMPath(prev) && isRiskUCMPath(now);

  // non-X → X aane par manual override reset
  if (cameFromOutsideCompliances) userToggledCompliancesRef.current = false;
  if (cameFromOutsideISO) userToggledISORef.current = false;
  if (cameFromOutsideRisk) userToggledRiskRef.current = false;
  if (cameFromOutsideRiskUCM) userToggledRiskUCMRef.current = false;

  // Auto-open Compliances
  if (isCompliancesPath(now) && !userToggledCompliancesRef) {
    if (openSection !== "compliances") {
      setOpenSection("compliances");
      localStorage.setItem("openSection", "compliances");
    }
  }

  // Auto-open ISO child
  if (isISOPath(now) && !userToggledISORef) {
    if (openISOSection !== "iso27001") {
      setOpenISOSection("iso27001");
      localStorage.setItem("openISOSection", "iso27001");
    }
  }
  // Auto-open Technical Risks sirf tab jab user ne manually close na kiya ho
  if (isTechPath(now) && !userToggledTechRef) {
    if (openSection !== "Technology&EmergingRisks") {
      setOpenSection("Technology&EmergingRisks");
      localStorage.setItem("openSection", "Technology&EmergingRisks");
    }
  }

  // Auto-open Risk Assessment parent
  if (isRiskPath(now) && !userToggledRiskRef) {
    if (openSection !== "riskAssessment") {
      setOpenSection("riskAssessment");
      localStorage.setItem("openSection", "riskAssessment");
    }
  }

  // Auto-open Risk UCM child
  if (isRiskUCMPath(now) && !userToggledRiskUCMRef) {
    if (openSubSection !== "unifiedControlMapping") {
      setOpenSubSection("unifiedControlMapping");
      localStorage.setItem("openRiskSubSection", "unifiedControlMapping");
    }
  }

  prevPathRef.current = now;

  

  
}, [location.pathname, openSection, openISOSection, openSubSection]);

// Menubar.jsx (top-level, state ke neeche)
const collapseAllMenus = () => {
  setOpenSection(null);
  setOpenSubSection(null);
  setOpenISOSection(null);
  localStorage.removeItem("openSection");
  localStorage.removeItem("openRiskSubSection");
  localStorage.removeItem("openISOSection");
};


































  const moduleItems = [
    {
    name: "SOC2",
    label: "SOC2",
    path: "/soc2",
    className: "SOC2",
   },
    {
    name: "nist sp 800-53",
    label: "NIST SP 800-53",
    path: "/nistsp80053",
    className: "NISTSP80053",
   },
   {
    name: "nist sp 800-63(iam)",
    label: "NIST SP 800-63(IAM)",
    path: "/nistsp80063iam",
    className: "NISTSP80063IAM",
   },
   {
    name: "nist privacy framework ",
    label: "NIST Privacy Framework",
    path: "/nistprivacyframework",
    className: "NISTP-icon",
   },
  {
    name: "dashboard",
    label: "Dashboard",
    path: "/",
    icon: DashboardLight,
    className: "dashboard-icon",
  },
  {
    name: "begin now",
    label: "Begin Now",
    path: "/overview",
    className: "begin-icon",
  },
  {
    name: "api integration",
    label: "API Integration",
    path: "/siemintegration",
    icon: APILight,
    className: "api-icon",
  },
  {
    name: "red",
    label: "RED",
    path: "/red",
    className: "red-icon",
  },
  {
     name: "annex a controls overview",
      label: "Annex A Controls Overview",
      path: "/annexacontrolsoverview",
  },
   {
        name: "organizational",
        label: "Organizational",
        path: "/organizational",
      },
      {
        name: "people",
        label: "People",
        path: "/people",
      },
      {
        name: "physical",
        label: "Physical",
        path: "/physical",
      },
      {
        name: "technological",
        label: "Technological",
        path: "/technological",
      },

  {
    name: "iso27001",
    label: "ISO27001",
    path: "/iso27001",
    className: "dashboard-icon-iso",

    submodules: [
      {
        name: "annex a controls overview",
        label: "Annex A Controls Overview",
        path: "/annexacontrolsoverview",
      },
      {
        name: "organizational",
        label: "Organizational",
        path: "/organizational",
      },
      {
        name: "people",
        label: "People",
        path: "/people",
      },
      {
        name: "physical",
        label: "Physical",
        path: "/physical",
      },
      {
        name: "technological",
        label: "Technological",
        path: "/technological",
      },
    ],
  },

 {
    name: "asset/inventory management",
    label: "Asset/Inventory Management",
    path: "/assetinventory",
    className: "asset-icon",
  },
  {
    name: "cis",
    label: "CIS",
    path: "/cissecurity",
    className: "cis-icon",
  },
  {
    name: "pci-dss",
    label: "PCI-DSS",
    path: "/pcidsscompliance",
    className: "pci-icon",
  },
   {
        name: "india dpdp act",
        label: "India DPDP Act",
        path: "/dpdpmodule",
      },
      {
        name: "ccpa",
        label: "CCPA",
        path: "/ccpamodule",
      },
     
      {
        name: "gdpr",
        label: "GDPR",
        path: "/gdpr",
      },
      {
        name: "uae data protection module",
        label: "UAE Data Protection Module",
        path: "/uaemodule",
      },
       {
        name: "uae pdpl",
        label: "UAE PDPl",
        path: "/pdpl",
      },
       
      {
        name: "data governance and risk management",
        label: "Data Governance and Risk Management",
        path: "/data&riskmgmt",
      },
       {
        name: "legal and regulatory compliance",
        label: "Legal and Regulatory Compliance",
        path: "/legalCompliance",
      },
      {
        name: "Privacy by Design and Engineering",
        label: "privacy by design and engineering",
        path: "/privacyengineering",
      },
       {
        name: "privacy program framework",
        label: "Privacy Program Framework",
        path: "/privacymaturity",
      },
  {
    name: "privacy/data protection",
    label: "Privacy/Data Protection",
    path: "Privacy/DataProtectioncompliance",
    icon: privacylight,
    className: "privacy-icon",

    submodules: [
      {
        name: "india dpdp act",
        label: "India DPDP Act",
        path: "/dpdpmodule",
      },
     
      {
        name: "ccpa",
        label: "CCPA",
        path: "/ccpamodule",
      },
      {
        name: "gdpr",
        label: "GDPR",
        path: "/gdpr",
      },
      
      {
        name: "uae data protection module",
        label: "UAE Data Protection Module",
        path: "/uaemodule",
      },
      {
        name: "uae pdpl",
        label: "UAE PDPl",
        path: "/pdpl",
      },
      {
        name: "data governance and risk management",
        label: "Data Governance and Risk Management",
        path: "/data&riskmgmt",
      },
       {
        name: "legal and regulatory compliance",
        label: "Legal and Regulatory Compliance",
        path: "/legalCompliance",
      },
       {
        name: "Privacy by Design and Engineering",
        label: "privacy by design and engineering",
        path: "/privacyengineering",
      },
       {
        name: "privacy program framework",
        label: "Privacy Program Framework",
        path: "/privacymaturity",
      },
      {
    name: "nist privacy framework ",
    label: "NIST Privacy Framework",
    path: "/nistprivacyframework",
   },
    ],
  },
  {
  name: "ot/iot",
    label: "OT/IOT Security",
    path: "/otiotsecurity",
    className: "OTIOT-icon",
  },
  {
  name: "generative ai risk ",
    label: "Generative AI Risk",
    path: "/genai",
    className: "gen-icon",
  }, {
  name: "application & database",
    label: "Application & Database",
    path: "/applicationdatabasesecurity",
    className: "database-icon",
  },
   {
    name: "aws cloud",
    label: "AWS Cloud",
    path: "aws cloud",
    icon: AWSLight,
    className: "dashboard-icon-aws",
    

    submodules: [
      {
        name: "iam",
        label: "IAM ",
        parentLabel: "AWS",
        path: "/iam",
      },
      {
        name: "detection",
        label: "Detection",
                parentLabel: "AWS",

        path: "/detection",
      },
      {
        name: "infrastructure protection",
        label: "Infrastructure Protection",
        parentLabel: "AWS",

        path: "/infrastructureprotection",
      },
      {
        name: "data protection",
        label: "Data Protection",
                parentLabel: "AWS",

        path: "/dataprotection",
      },
      {
        name: "incident response & automation",
        label: "Incident Response & Automation",
         parentLabel: "AWS",

        path: "/inscidentresponseandautomation",
      },
    
      {
      name: "app security scanner",
      label: "App Security Scanner",
      path: "/dast-scanner",
      icon: securityscan,
      className: "scanicon",
    }, 
    ],
  },
  //  {
  //       name: "iam",
  //       label: "IAM (AWS)",
  //       path: "/iam",
  //     },
  //     {
  //       name: "detection",
  //       label: "Detection (AWS)",
  //       path: "/detection",
  //     },
  //     {
  //       name: "infrastructure protection",
  //       label: "Infrastructure Protection (AWS)",
  //       path: "/infrastructure_protection",
  //     },
  //      {
  //       name: "data protection",
  //       label: "Data Protection (AWS)",
  //       path: "/dataprotection",
  //     },
  //      {
  //       name: "incident response & automation",
  //       label: "Incident Response & Automation (AWS)",
  //       path: "/inscidentresponseandautomation",
  //     },
  
   {
    name: "azure/entra cloud",
    label: "Azure/Entra Cloud",
    path: "azure",
    icon:AzureLight,
    className: "dashboard-icon-azure",
    

    submodules: [
      {
        name: "iam",
        label: "IAM",
        parentLabel: "Azure",

        path: "/iamazurecloudsecurity",
      },
      {
        name: "detection",
        label: "Detection",
        parentLabel: "Azure",
        path: "/detectionazure",
      },
      {
        name: "infrastructure protection",
        label: "Infrastructure Protection",
        parentLabel: "Azure",
        path: "/infrastructureprotectionazure",
      },
      {
        name: "data protection",
        label: "Data Protection",
        parentLabel: "Azure",
        path: "/dataprotectionazure",
      },
      {
        name: "incident response & automation",
        label: "Incident Response & Automation",
        parentLabel: "Azure",
        path: "/aiazure",
      },
    ]},
  // {
  //       name: "iam",
  //       label: "IAM (Azure)",
  //       path: "/iamazurecloudsecurity",
  //     },
  //     {
  //       name: "detection",
  //       label: "Detection (Azure)",
  //       path: "/detectionazure",
  //     },
  //     {
  //       name: "infrastructure protection",
  //       label: "Infrastructure Protection (Azure)",
  //       path: "//infrastructureprotectionazure",
  //     },
  //     {
  //       name: "data protection",
  //       label: "Data Protection (Azure)",
  //       path: "/dataprotectionazure",
  //     },
  //      {
  //       name: "incident response & automation",
  //       label: "Incident Response & Automation (Azure)",
  //       path: "/aiazure",
  //     },
 
     {
        name: "iam and mfa",
        label: "IAM and MFA",
        path: "/iamandmfa",
      },
       {
        name: "user administration",
        label: "User Administration",
        path: "/useradministration",
      },
      {
        name: "microsoft intunes user enrollment and management",
        label: "Microsoft InTunes User Enrollment And Management",
        path: "/intunesuserenrollmentandmanagement",
      },
       {
        name: "group policies",
        label: "Group Policies",
        path: "/grouppolicies",
      },
       {
        name: "hybrid connect",
        label: "Hybrid Connect",
        path: "/hybridconnect",
      },
      {
        name: "on-premises to cloud migration",
        label: "On-Premises To Cloud Migration",
        path: "/onpremtocloudmigration",
      },
      {
        name: "windows user bit locker encryption",
        label: "Windows User Bit Locker Encryption",
        path: "/windowsuserbitlockerencryption",
      },
         {
        name: "windows user firewall management",
        label: "Windows User Firewall Management",
        path: "/windowsuserfirewallmanagement",
      },
        {
        name: "windows user patching",
        label: "Windows User Patching",
        path: "/windowsuserpatching",
      },
       {
        name: "sso and enterprise applications",
        label: "SSO and Enterprise applications",
        path: "/ssoandenterpriseapplications",
      },
       {
        name: "sentinel",
        label: "Sentinel",
        path: "/sentinel",
      },
{
    name: "m365",
    label: "M365",
    path: "m365",
    icon: mlight,
    className: "dashboard-icon-m365",
    

    submodules: [
      {
        name: "iam and mfa",
        label: "IAM and MFA",
        path: "/iamandmfa",
      },
      {
        name: "user administration",
        label: "User Administration",
        path: "/useradministration",
      },
      {
        name: "microsoft intunes user enrollment and management",
        label: "Microsoft InTunes User Enrollment And Management",
        path: "/intunesuserenrollmentandmanagement",
      },
      {
        name: "group policies",
        label: "Group Policies",
        path: "/grouppolicies",
      },
      {
        name: "hybrid connect",
        label: "Hybrid Connect",
        path: "/hybridconnect",
      },
       {
        name: "on-premises to cloud migration",
        label: "On-Premises To Cloud Migration",
        path: "/onpremtocloudmigration",
      },
       {
        name: "windows user bit locker encryption",
        label: "Windows User Bit Locker Encryption",
        path: "/windowsuserbitlockerencryption",
      },
       {
        name: "windows user firewall management",
        label: "Windows User Firewall Management",
        path: "/windowsuserfirewallmanagement",
      },
       {
        name: "windows user patching",
        label: "Windows User Patching",
        path: "/windowsuserpatching",
      },
       {
        name: "sso and enterprise applications",
        label: "SSO and Enterprise applications",
        path: "/ssoandenterpriseapplications",
      },
       {
        name: "sentinel",
        label: "Sentinel",
        path: "/sentinel",
      },
    ]},
      {
    name: "google cloud",
    label: "Google Cloud",
    path: "googlecloud",
    icon: CloudLight,
    className: "dashboard-icon-cloud",
    

    submodules: [
      {
        name: "iam",
        label: "IAM ",
    parentLabel: "Google",

        path: "/iamgoogle",
      },
      {
        name: "detection",
        label: "Detection",
            parentLabel: "Google",

        path: "/detectiongoogle",
      },
      {
        name: "infrastructure protection",
        label: "Infrastructure Protection",
            parentLabel: "Google",

        path: "/infrastructureprotectiongoogle",
      },
      {
        name: "data protection",
        label: "Data Protection",
            parentLabel: "Google",

        path: "/dataProtectionGoogle",
      },
      {
        name: "incident response & automation",
        label: "Incident Response & Automation",
            parentLabel: "Google",

        path: "/aiGoogle",
      },
    ]},
    // {
    //     name: "iam",
    //     label: "IAM (Google)",
    //     path: "/iamgoogle",
    //   },
    //   {
    //     name: "detection",
    //     label: "Detection (Google)",
    //     path: "/detectiongoogle",
    //   },
    //    {
    //     name: "infrastructure protection",
    //     label: "Infrastructure Protection (Google)",
    //     path: "/infrastructureprotectionazure",
    //   },
    //    {
    //     name: "data protection",
    //     label: "Data Protection (Google)",
    //     path: "/dataProtectionGoogle",
    //   },
    //   {
    //     name: "incident response & automation",
    //     label: "Incident Response & Automation (Google)",
    //     path: "/aiGoogle",
    //   },
    
{
     name: "devsecops",
    label: "DevSecOps",
    path: "/devsecops",
    className: "devsecops-icon",
},
{
     name: "private cloud/hypervisor",
    label: "Private Cloud/Hypervisor",
    path: "/privatecloudhypervisor",
    className: "hypervisor",
},
{
        name: "network security",
        label: "Network Security",
        path: "/networksecurity",
      },
      {
        name: "cisco",
        label: "Cisco",
        path: "/cisco",
      },
        {
        name: "juniper",
        label: "Juniper",
        path: "/juniper",
      },
      {
        name: "fortinet",
        label: "Fortinet",
        path: "/fortinet",
      },
            {
        name: "palo alto",
        label: "Palo Alto",
        path: "/paloalto",
      },
      {
        name: "checkpoint",
        label: "Checkpoint",
        path: "/checkpoint",
      },
 {
    name: "network infrastructure",
    label: "Network Infrastructure",
    path: "/networkinfrastructure",
    icon: network,
    className: "network-icon",
    

    submodules: [
      {
        name: "network security",
        label: "Network Security",
        path: "/networksecurity",
      },
      {
        name: "cisco",
        label: "Cisco",
        path: "/cisco",
      },
      {
        name: "juniper",
        label: "Juniper",
        path: "/juniper",
      },
      {
        name: "fortinet",
        label: "Fortinet",
        path: "/fortinet",
      },
      {
        name: "palo alto",
        label: "Palo Alto",
        path: "/paloalto",
      },
      {
        name: "checkpoint",
        label: "Checkpoint",
        path: "/checkpoint",
      },
    ]},
{
    name: "operational resilience",
    label: "operational Resilience",
    path: "/operationalresilience",
    className: "oparational-icon",
},
{
        name: "mitre",
        label: "MIREW",
        path: "/mitre",
},
{
        name: "owasp",
        label: "OWASP",
        path: "/owasp",
},
{
        name: "cobit",
        label: "COBIT",
        path: "/cobit",
},

{
  name: "oracle cloud",
    label: "Oracle Cloud",
    path: "oraclecloud",
    icon: oraclecloud,
    className: "dashboard-icon-cloud",
    

    
    submodules: [
      {
        name: "iam",
        label: "IAM ",
    parentLabel: "Oracle",
     path: "/iamoracle",
      },
      {
        name: "detection",
        label: "Detection",
        parentLabel: "Oracle",
        path: "/detectionoracle",
      },
      {
        name: "infrastructure protection",
        label: "Infrastructure Protection",
       parentLabel: "Oracle",
        path: "/infrastructureprotectionoracle",
      },
      {
        name: "data protection",
        label: "Data Protection",
        parentLabel: "Oracle",
        path: "/dataprotectionoracle",
      },
      {
        name: "incident response & automation",
        label: "Incident Response & Automation",
        parentLabel: "oracle",

        path: "/incidentresponseoracle",
      },
    ]},

{
    name: "blockchain",
    label: "Blockchain",
    path: "/blockchainsecurity",
    className: "blockchain-icon",
},{
    name: "wireless",
    label: "Wireless",
    path: "/wirelesssecurity",
    className: "wireless-icon",
},
 {
        name: "dora",
        label: "DORA",
        path: "/dora",
},
{
        name: "cra",
        label: "CRA",
        path: "/cra",
},
{
        name: "nis2",
        label: "NIS2",
        path: "/nis2",
},
{
        name: "cscrf by sebi",
        label: "CSCRF by SEBI",
        path: "/cscrfbysebi",
},
{
  name:"cscrf checklist",
  label:"CSCRF Checklist",
  path:"/cscrfchecklist",
},
{
        name: "National cyber security bill",
        label: "National Cyber Security Bill",
        path: "/nationalcybersecuritybill",
},
{
        name: "circia",
        label: "CIRCIA",
        path: "/circia",
},
{
        name: "upcoming ai executive orders",
        label: "Upcoming AI Executive orders",
        path: "/upcomingaiexecutiveorders",
},
{
        name: "sox compliance",
        label: "SOX Compliance",
        path: "/soxcompliance",
},
{
        name: "icfr",
        label: "ICFR",
        path: "/icfr",
},
{
        name: "hipaa",
        label: "HIPAA",
        path: "/hipaa",
},
{
        name: "cyber security and resilience bill",
        label: "Cyber Security And Resilience Bill",
        path: "/cybersecurityandresiliencebill",
},
{
        name: "govassure program",
        label: "GovAssure Program",
        path: "/govassureprogram",
},
{
        name: "incident reporting",
        label: "Incident Reporting",
        path: "/incidentreporting",
},
{
        name: "third-party infrastructure",
        label: "Third-Party Infrastructure",
        path: "/third-partyinfrastructure",
},
{
        name: "regulatory engagement",
        label: "Regulatory Engagement",
        path: "/regulatoryengagement",
},
{
        name: "encryption & ico readiness",
        label: "Encryption & ICO Readiness",
        path: "/encryption&icoreadiness",
},
{
        name: "quantum-resilient security",
        label: "Quantum-Resilient Security",
        path: "/quantum-resilientsecurity",
},
{
        name: "pecr compliance",
        label: "PECR Compliance",
        path: "/pecrcompliance",
},
{
        name: "telecom security act",
        label: "Telecom Security Act",
        path: "/telecomsecurityact",
},
{
        name: "ncsc caf",
        label: "NCSC CAF",
        path: "/ncsccaf",
},
{
        name: "psn",
        label: "PSN",
        path: "/psn",
},
{
        name: "ps21/3",
        label: "PS21/3",
        path: "/ps21/3",
},
{
   name: "cyber essential",
        label: "Cyber Essential",
        path: "/cyberessential",

},
{
    name: "eu",
    label: "EU",
    path: "/eu",
    icon: eu,
    className: "country-flag-icon",
    

    submodules: [
     {
        name: "dora",
        label: "DORA",
        path: "/dora",
},
{
        name: "cra",
        label: "CRA",
        path: "/cra",
},
{
        name: "nis2",
        label: "NIS2",
        path: "/nis2",
},
]},
{
    name: "india",
    label: "India",
    path: "/india",
    icon: india,
    className: "country-flag-icon",
    

    submodules: [
     {
        name: "cscrf by sebi",
        label: "CSCRF by SEBI",
        path: "/cscrfbysebi",
},
{
  name:"cscrf checklist",
  label:"CSCRF Checklist",
  path:"/cscrfchecklist"
}
]},
{
    name: "ireland",
    label: "Ireland",
    path: "/ireland",
    icon: ireland,
    className: "country-flag-icon",
    

    submodules: [
     {
        name: "National cyber security bill",
        label: "National Cyber Security Bill",
        path: "/nationalcybersecuritybill",
},
]},
{
    name: "uk",
    label: "UK",
    path: "/uk",
    icon: uk,
    className: "country-flag-icon",
    

    submodules: [
     {
        name: "cyber security and resilience bill",
        label: "Cyber Security And Resilience Bill",
        path: "/cybersecurityandresiliencebill",
},
{
        name: "govassure program",
        label: "GovAssure Program",
        path: "/govassureprogram",
},
{
        name: "incident reporting",
        label: "Incident Reporting",
        path: "/incidentreporting",
},
{
        name: "third-party infrastructure",
        label: "Third-Party Infrastructure",
        path: "/third-partyinfrastructure",
},
{
        name: "regulatory engagement",
        label: "Regulatory Engagement",
        path: "/regulatoryengagement",
},
{
        name: "encryption & ico readiness",
        label: "Encryption & ICO Readiness",
        path: "/encryption&icoreadiness",
},
{
        name: "quantum-resilient security",
        label: "Quantum-Resilient Security",
        path: "/quantum-resilientsecurity",
},
{
        name: "pecr compliance",
        label: "PECR Compliance",
        path: "/pecrcompliance",
},
{
        name: "telecom security act",
        label: "Telecom Security Act",
        path: "/telecomsecurityact",
},
{
        name: "ncsc caf",
        label: "NCSC CAF",
        path: "/ncsccaf",
},
{
        name: "psn",
        label: "PSN",
        path: "/psn",
},
{
        name: "ps21/3",
        label: "PS21/3",
        path: "/ps21/3",
},
{
  
        name: "cyber essential",
        label: "Cyber Essential",
        path: "/cyberessential",

},
]},
{
    name: "usa",
    label: "USA",
    path: "/usa",
    icon: usa,
    className: "country-flag-icon",
    

    submodules: [
     {
        name: "circia",
        label: "CIRCIA",
        path: "/circia",
},
{
        name: "upcoming ai executive orders",
        label: "Upcoming AI Executive orders",
        path: "/upcomingaiexecutiveorders",
},
{
        name: "hipaa",
        label: "HIPAA",
        path: "/hipaa",
},
{
        name: "sox compliance",
        label: "SOX Compliance",
        path: "/soxcompliance",
},
{
        name: "icfr",
        label: "ICFR",
        path: "/icfr",
},
]},
 {
    name: "unified control mapping",
    label: "Unified Control Mapping",
    path: "unified control mapping",
    className: "dashboard-icon-ucm",
     submodules: [
      {
        name: "security controls",
        label: "Security Controls",
        path: "/securitycontrols",
      },
      {
        name: "privacy controls",
        label: "Privacy Controls",
        path: "/privacycontrols",
      },
      
       
    ],
  },

  {
        name: "security controls",
        label: "Security Controls",
        path: "/securitycontrols",
      },
       {
        name: "privacy controls",
        label: "Privacy Controls",
        path: "/privacycontrols",
      },
   
{
    name: "supply chain risk",
    label: "Supply Chain Risk",
    path: "supply chain risk",
    icon: SupplyChain,
    className: "privacy-icon",
    

    submodules: [
      {
        name: "nist sp 800-161",
        label: "NIST SP 800-161",
        path: "/nist",
      },
      {
        name: "ncsc supply chain guidelines",
        label: "NCSC Supply Chain Guidelines",
        path: "/ncsc",
      },
      {
        name: "cert-iN ",
        label: "Cert-IN ",
        path: "/certin",
      },
      {
        name: "nis2",
        label: "NIS2",
        path: "/nis2",
},
      
       
    ],
  },
  {
        name: "nist sp 800-161",
        label: "NIST SP 800-161",
        path: "/nist",
      },
  {
        name: "ncsc supply chain guidelines",
        label: "NCSC Supply Chain Guidelines",
        path: "/ncsc",
      },
       {
        name: "cert-iN ",
        label: "Cert-IN ",
        path: "/certin",
      },
      {
        name: "dpdp-assessment",
        label: "DPDP-Assessment",
        path: "/dpdp-assessment",
      },
       {
        name: "security awareness",
        label: "Security Awareness",
        path: "/phishingassessment",
      },
      {
        name: "appsec-assessment",
        label: "DAST-Assessment",
        path: "/appsec-assessment",
      },
];





function filterModules(modules, searchTerm) {
  return modules.flatMap((item) => {
    const matchSelf =
      item.name.toLowerCase().includes(searchTerm) ||
      item.label?.toLowerCase().includes(searchTerm);

    if (matchSelf) {
      // ✅ Agar parent match kare → pura module wapas do (submodules intact)
      return [item];
    }

    // Agar parent match nahi hua to submodules check karo
    const filteredSubs = item.submodules
      ? filterModules(item.submodules, searchTerm)
      : [];

    if (filteredSubs.length > 0) {
      // ✅ Agar submodules match kare → parent ke andar sirf wo submodules wapas do
      return {
        ...item,
        submodules: filteredSubs,
      };
    }

    return [];
  });
}

const filteredModules = filterModules(moduleItems, searchTerm);



// 🔹 Add this helper function near top (inside component)
const handleSearchItemClick = (item) => {
  // Close search view
  setSearchTerm("");

  // Figure out which parent module this item belongs to
  if (COMPLIANCES_SUBPATHS.includes(item.path)) {
    setOpenSection("compliances");
  } else if (ISO_SUBPATHS.includes(item.path)) {
    setOpenSection("compliances");
    setOpenISOSection("iso27001");
  } else if (RISK_ALL_SUBPATHS.includes(item.path)) {
    setOpenSection("riskAssessment");
  } else if (TECH_SUBPATHS.includes(item.path)) {
    setOpenSection("Technology&EmergingRisks");
  } else if (NETWORK_SUBPATHS.includes(item.path)) {
    setOpenSection("networkinfrastructure");
  } else if (AWS_SUBPATHS.includes(item.path)) {
    setOpenSection("aws cloud");
  } else if (AZURE_SUBPATHS.includes(item.path)) {
    setOpenSection("azure");
  } else if (GOOGLE_SUBPATHS.includes(item.path)) {
    setOpenSection("googlecloud");
  } else if (M365_SUBPATHS.includes(item.path)) {
    setOpenSection("m365");
  } else if (PRIVACY_SUBPATHS.includes(item.path)) {
    setOpenSection("Privacy/DataProtectioncompliance");
  } else if (SUPPLYCHAIN_SUBPATHS.includes(item.path)) {
    setOpenSection("supply chain risk");
  }

  // navigate to clicked module
  navigate(item.path);
};





























































  


// const filteredModules = moduleItems.filter((item) =>
//   item.name.toLowerCase().includes(searchTerm)
// );


const handleToggle = () => {
  onToggle();          // pehle sidebar collapse/expand toggle karo

  if (!isCollapsed) {
    // Agar collapse kar rahe hain to openSection reset kar do
setOpenSection(null);
    setOpenSubSection(null);
    setOpenISOSection(null);
    localStorage.removeItem("openSection");
    localStorage.removeItem("openRiskSubSection");
    localStorage.removeItem("openISOSection");
  
  
  }
};


const getAutoQuickLabel = (moduleObj) => {
  if (!moduleObj) return "";

  if (moduleObj.parentLabel) {
    return `${moduleObj.label} (${moduleObj.parentLabel})`;
  }

  return moduleObj.label;
};




  return (
    <>
    
 
      
    


<div className="sidebar-header">
  <div className="susan-header">
    {!isCollapsed && <img src={logo} alt="SUSAN" className="Logo2" />}
    <button
      type="button"
      className="toggle-arrow"
      onClick={handleToggle}                  
      aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
    >
      {isCollapsed ? <FaArrowRight /> : <FaArrowLeft />}
    </button>
  </div>    
 

  {!isCollapsed && (
    <div className="menu-search-box">
      <FaSearch className="search-icon" />
      <input
        className="module-search-input"
        type="text"
        placeholder="Search modules..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
      />
    </div>
  )}
</div>
           






            
{/* <div>
<div className="susan-header">
  <div>
  {!isCollapsed && (
    <img
      src={logo}
      alt="SUSAN"
      className="Logo2"
    />
  )}
  </div>

  <div
    type="button"
    className="toggle-arrow"
    aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        onClick={handleToggle}

  >
    {isCollapsed ? <FaArrowRight /> : <FaArrowLeft />}
  </div>
</div>

{!isCollapsed && (
  <div className="menu-search-box">
    <FaSearch className="search-icon" />
    <input
      type="text"
      placeholder="Search modules..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
      className="module-search-input"
    />
  </div>
)}
</div> */}

<Container className={`sidebar-container ${isCollapsed ? "collapsed" : ""}`}>
      
       {/* <img src={logo} 
            alt="susan logo " 
            className="Logo2" /> */}
      
      
      <Row>
        <Col
          xs={12}
          md={isCollapsed ? 1 : 3}
          className={`sidebar ${isCollapsed ? "collapsed" : ""}`}
        >
          <nav className="nav">







<div className="menu-scroll">

{searchTerm && (
  <ul className="search-results">
    {filteredModules.length === 0 ? (
      <li className="no-results">No modules found</li>
    ) : (
      filteredModules.map((item) => (  

      <React.Fragment key={item.path || item.name}>
   <li
  className={`heading-home ${isActive(item.path) ? "active" : ""}`}
  onClick={() => {
    if (item.submodules) {
      toggleSection(item.name);
    } else {
      // ✅ Close search
      setSearchTerm("");

      // ✅ Auto-open parent based on path
      if (COMPLIANCES_SUBPATHS.includes(item.path)) {
        setOpenSection("compliances");
      } else if (ISO_SUBPATHS.includes(item.path)) {
        setOpenSection("compliances");
        setOpenISOSection("iso27001");
      } else if (RISK_ALL_SUBPATHS.includes(item.path)) {
        setOpenSection("riskAssessment");
      } else if (TECH_SUBPATHS.includes(item.path)) {
        setOpenSection("Technology&EmergingRisks");
      } else if (NETWORK_SUBPATHS.includes(item.path)) {
        setOpenSection("networkinfrastructure");
      } else if (AWS_SUBPATHS.includes(item.path)) {
        setOpenSection("aws cloud");
      } else if (AZURE_SUBPATHS.includes(item.path)) {
        setOpenSection("azure");
      } else if (GOOGLE_SUBPATHS.includes(item.path)) {
        setOpenSection("googlecloud");
      } else if (M365_SUBPATHS.includes(item.path)) {
        setOpenSection("m365");
      } else if (PRIVACY_SUBPATHS.includes(item.path)) {
        setOpenSection("Privacy/DataProtectioncompliance");
      } else if (SUPPLYCHAIN_SUBPATHS.includes(item.path)) {
        setOpenSection("supply chain risk");
      }

      // ✅ Now navigate to module
      handleSubmenuClick(item.path);
    }
  }}
>



        
          {item.icon && (
            <img
              src={item.icon}
              alt={item.label}
              className={item.className}
            />
          )}
          <span>{item.label}</span>
        </li>

        {/* ✅ Submodules render */}
        {item.submodules &&
          openSection?.toLowerCase() === item.name.toLowerCase() && (
            <ul className="sub-menu">
              {item.submodules.map((sub) => (
                <React.Fragment key={sub.path || sub.name}>
                  <li
                    className={isActive(sub.path) ? "active" : ""}
                    onClick={() =>
                      sub.submodules
                        ? toggleSection(sub.name)
                        : handleSubmenuClick(sub.path)
                    }
                  >
                    {sub.icon && (
                      <img
                        src={sub.icon}
                        alt={sub.label}
                        className={sub.className}
                      />
                    )}
                    <span style={{ color: "white" }}>{sub.label}</span>
                  </li>

                  {/* ✅ Sub-submodules render */}
                  {sub.submodules &&
                    openSection?.toLowerCase() === sub.name.toLowerCase() && (
                      <ul className="sub-sub-menu">
                        {sub.submodules.map((grand) => (
                          <li
                            key={grand.path}
                            className={isActive(grand.path) ? "active" : ""}
                            onClick={() => handleSubmenuClick(grand.path)}
                          >
                            <span style={{ color: "white" }}>
                              {grand.label}
                            </span>
                          </li>
                        ))}
                      </ul>
                    )}
                </React.Fragment>
              ))}
            </ul>
          )}
      </React.Fragment>
    ))
  )}
  </ul>
)}





{/* {searchTerm && (
  <>
    <ul className="search-results">
  {filteredModules.map((item) => (
    <li
      key={item.path}
      className={`heading-home ${isActive(item.path) ? "active" : ""}`}
      onClick={() =>
        item.submodules
          ? toggleSection(item.name)
          : handleSubmenuClick(item.path)
      }
    >
      {item.icon && (
        <img
          src={item.icon}
          alt={item.label}
          className={item.className}
        />
      )}
      <span>{item.label}</span>
    </li>
  ))}
</ul>

   {filteredModules.map((item) =>
  item.submodules && openSection?.toLowerCase() === item.name.toLowerCase() ? (
    <ul className="sub-menu" key={`${item.name}-subs`}>
      {item.submodules.map((sub) => (
        <li
          key={sub.path}
          className={isActive(sub.path) ? "active" : ""}
          onClick={() => handleSubmenuClick(sub.path)}
        >
          <span style={{ color: "white" }}>{sub.label}</span>
        </li>
      ))}
    </ul>
  ) : null
)}

  </>
)} */}






















              
              <ul>
               
    
                {!searchTerm && (
                  <div className="heading-home dashboard-countainer">
                  <li
                    className={isActive("/") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/")}
                  >
                    <img
                    src={DashboardLight}
                    alt="Dashboard "
                    className="dashboard-icon"
                    title="dashboard"
                    />
                 
                    <span className="dashboard">Dashboard</span>


                  </li>
                  </div>
                )}


 {!searchTerm && (
                    <div
                      className="heading-home api-countainer"
                      title="Global Compliance & Trust"
                    >
                      <li
                        to="/trust"
                        className={isActive("/trust") ? "active" : ""}
                        onClick={() => handleSubmenuClick("/trust")}
                      >
                        {/* <img
                          src={gticon}
                          alt="Global Trust"
                          className="scanicon-gt"
                          title="Global Compliance & Trust"
                        /> */}
                        <span style={{ color: "#fff", marginLeft: "15px" }}>
                          {" "}
                          Global Compliance & Trust{" "}
                        </span>
                      </li>
                    </div>
                  )}
 


{!searchTerm && (
  <li
    className="heading privacy-countainer"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("Trainingsandassesment");
      } else {
        toggleSection("Trainingsandassesment");
      }
    }}
  >
   <img  
                   src={traingassessment}
                    alt="Trainings and Assesment"
                    className="begin-icon"
                    title="Trainings and Assesment"
                    />
    <span className="Privacy-Data-Protection">Training & Assessment</span>
    <img
      src={openSection === "Trainingsandassesment" ? chevdown : chevronright}
      alt=""
      className="chevron-icon-privacy"
    />
  </li>
)}
{openSection === "Trainingsandassesment" && !isCollapsed && (
<ul className="sub-menu">
{!searchTerm && (
 
                  <li
                    className={isActive("/phishingassessment") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/phishingassessment")}
                  >
                     
                   <span style={{ color: "white" }}>Security Awareness</span>
                    {renderPinButton("/phishingassessment")}
 
                   
                  </li>
    )}
     {!searchTerm && (
 
                  <li
                    className={isActive("/dpdp-assessment") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/dpdp-assessment")}
                  >
                   
                   <span style={{ color: "white" }}>DPDP Training</span>
                    {renderPinButton("/dpdp-assessment")}
 
                   
                  </li>
    )}
     {!searchTerm && (
 
                  <li
                    className={isActive("/appsec-assessment") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/appsec-assessment")}
                  >
                   
                   <span style={{ color: "white" }}>DAST Training</span>
                    {renderPinButton("/appsec-assessment")}
 
                   
                  </li>
    )}
</ul>
)}

                {/* After the Dashboard li */}
{/* {!isCollapsed && pinned.length > 0 && (
  <div className="pinned-modules-section">
    <ul className="sub-menu">
      {pinned.map((p) => {
        const m = findModuleByPath(moduleItems, p);
        if (!m) return null;
        return (
          <li
  key={p}
  className={isActive(p) ? "active" : ""}
onClick={(e) => {
  e.stopPropagation();
  sessionStorage.setItem("suppressAutoOpenOnce", "true"); 
  saveSidebarScroll();
  navigate(p);
  if (window.innerWidth <= 768) {
    onToggle?.();
    setIsSidebarCollapsed(prev => !prev);
  }
}}

>
  {m.icon && <img src={m.icon} alt={m.label} className={m.className} />}
  <span style={{ color: "white" }}>{m.label}</span>
  {renderPinButton(p)}
</li>

        );
      })}
    </ul>
  </div>
)} */}

{!searchTerm && (
  <li
    className="heading privacy-countainer"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("quickaccess");
      } else {
        toggleSection("quickaccess");
      }
    }}
  >
   <img
                    src={access}
                    alt=" Quick Access "
                    className="begin-icon"
                    title="Quick Access"
                    />
    <span className="Privacy-Data-Protection">Quick Access</span>
    <img
      src={openSection === "quickaccess" ? chevdown : chevronright}
      alt=""
      className="chevron-icon-privacy"
    />
  </li>
)}


{openSection === "quickaccess" && !isCollapsed && (
  <ul className="sub-menu">
   
    {/* ✅ Show note when no modules are pinned */}
    {!searchTerm && !isCollapsed && pinned.length === 0 && (
      <div className="quick-access-note" style={{
        padding: "12px 16px",
        margin: "8px 12px",
        borderRadius: "6px",
        color: "white",
        fontSize: "13px",
        lineHeight: "1.5"
      }}>
        <span style={{ color: "#ff9800", fontWeight: "600" , marginRight:"3px" }}>ℹ️ Note:</span>
{"   "}  Pinned modules will appear here once added.
 
      </div>
    )}
 
    {/* ✅ Show pinned modules when available */}
    {!searchTerm && !isCollapsed && pinned.length > 0 && (
      <div className="pinned-modules-section">
        <ul className="sub-menu">
         
          {pinned.map((p) => {
            const m = findModuleByPath(moduleItems, p);
            if (!m) return null;
 
            const isParent = Array.isArray(m.submodules) && m.submodules.length > 0;
           
            // ✅ Parent module pinned in Quick Access (like Unified Control Mapping)
            if (isParent) {
              const isOpen = !!quickAccessOpen[p];
 
              return (
                <li
                  key={p}
                  className={`quick-parent ${isOpen ? "open" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    // just toggle expand/collapse (no navigation)
                    toggleQuickAccessOpen(p);
                  }}
                >
                  <div className="qa-parent-row">
                    {m.icon && <img src={m.icon} alt={m.label} className={m.className} />}
                    <span className="qa-parent-label">{m.label}</span>
                    <span className="qa-parent-right">
                      {renderPinButton(p)}
                      <img
                        src={isOpen ? chevronup : chevrondown}
                        alt="Chevron"
                        className="qa-chevron-icon"
                      />
                    </span>
                  </div>
 
                  {/* ✅ show children inside Quick Access only */}
                  {isOpen && (
                    <ul className="qa-submodule">
                      {m.submodules.map((sub) => (
                        <li
                          key={sub.path}
                          className={isActive(sub.path) ? "active" : ""}
                          onClick={(e) => {
                            e.stopPropagation();
 
                            // mark this click as from Quick Access
                            sessionStorage.setItem("fromQuickAccess", "1");
                            sessionStorage.setItem("suppressAutoOpenOnce", "1");
                            keepQuickAccessOpenOnce?.();
 
                            // prevent Risk Assessment auto-open
                            markKeepOpenOnNextRoute?.(sub.path);
 
                            // navigate normally
                            saveSidebarScroll?.();
                            navigate(sub.path);
 
                            if (window.innerWidth <= 768) {
                              onToggle?.();
                              setIsSidebarCollapsed((prev) => !prev);
                            }
                          }}
                        >
                          {sub.icon && (
                            <img src={sub.icon} alt={sub.label} className={sub.className} />
                          )}
                          <span style={{ color: "white" }}>{sub.label}</span>
                          {!pinned.includes(p) && renderPinButton(sub.path)}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            }
 
            // Leaf pinned item: normal navigate
            return (
              <li
                key={p}
                className={isActive(p) ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  sessionStorage.setItem("fromQuickAccess", "1");
                  sessionStorage.setItem("suppressAutoOpenOnce", "1");
                  keepQuickAccessOpenOnce?.();
                  markKeepOpenOnNextRoute?.(p);
                  saveSidebarScroll?.();
                  navigate(p);
                  if (window.innerWidth <= 768) {
                    onToggle?.();
                    setIsSidebarCollapsed((prev) => !prev);
                  }
                }}
              >
                {m.icon && <img src={m.icon} alt={m.label} className={m.className} />}
                <span style={{ color: "white" }}>{getAutoQuickLabel(m)}</span>
                {renderPinButton(p)}
              </li>
            );
          })}
        </ul>
      </div>
    )}
  </ul>
)}


                

{/* ===== Risk Assessment (parent) ===== */}
{!searchTerm && (
  <li
    className="heading privacy-countainer"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("riskAssessment");
      } else {
        toggleSection("riskAssessment");
      }
    }}
  >
   <img
                    src={BeingAssesmentLight}
                    alt="  Risk/Assessment"
                    className="begin-icon"
                    title="Risk Assessment"
                    />
    <span className="Privacy-Data-Protection">Risk Assessment</span>
    <img
      src={openSection === "riskAssessment" ? chevdown : chevronright}
      alt=""
      className="chevron-icon-privacy"
    />
  </li>
)}

{/* ===== Risk Assessment → children (shown only when parent open) ===== */}
{openSection === "riskAssessment" && !isCollapsed && (
  <ul className="sub-menu">
    {/* Begin Now */}
    {!searchTerm &&   (

    <li
      className={isActive("/overview") ? "active" : ""}
      onClick={() => {  handleSubmenuClick("/overview"); }}
    >
       
      <span className="Begin-Risk">Begin Now</span>

      {renderPinButton("/overview")}
    </li>
    )}
    {/* Unified Control Mapping (this is a parent inside Risk Assessment) */}
    {!searchTerm && (
      <li
        className=" iso-container"
        onClick={(e) => {
          e.stopPropagation();
          // if sidebar was collapsed, expand first then open sub
          if (isCollapsed) {
            onToggle();
            // ensure parent opens
            toggleSection("riskAssessment");
            // then open nested
            toggleSubSection("unifiedControlMapping");
          } else {
            toggleSubSection("unifiedControlMapping");
          }
        }}
      >
       
        <span className="Unified">Unified Control Mapping</span>

        <img
          src={openSubSection === "unifiedControlMapping" ? chevronup : chevrondown}
          alt="Chevron"
          className="chevron-icon-iso"
        />

      </li>
    )}

    {/* Unified Control Mapping → actual submodules */}

    {openSubSection === "unifiedControlMapping" && !isCollapsed && (
      <ul className="sub-sub-menu1">
        {!searchTerm &&  (

        <li
          className={isActive("/securitycontrols") ? "active" : ""}
          onClick={() => handleSubmenuClick("/securitycontrols") }
        >
          <span className="unified1 ms-2">Security Controls</span>
          {moduleProgress?.SecurityControls && (
            <span className="progress-indicator">
              ({moduleProgress.SecurityControls.completed}/{moduleProgress.SecurityControls.total})
            </span>
            
          )}
          {renderPinButton("/securitycontrols")}
        </li>
        )}
        {!searchTerm && (

        <li
          className={isActive("/privacycontrols") ? "active" : ""}
          onClick={() => handleSubmenuClick("/privacycontrols")}
        >
          <span className="unified1 ms-2">Privacy Controls</span>
          {moduleProgress?.PrivacyControls && (
            <span className="progress-indicator">
              ({moduleProgress.PrivacyControls.completed}/{moduleProgress.PrivacyControls.total})
            </span>
          )}
                    {renderPinButton("/privacycontrols")}

        </li>
        )}
      </ul>
    )}

    {/* Asset/Inventory Management */}
    {!searchTerm && (

    <li
      className={isActive("/assetinventory") ? "active" : ""}
  onClick={() => { handleSubmenuClick("/assetinventory"); }}
    >
        {/* <img
                    src={AssetLight}
                    alt="  Asset/Inventory Management"
                    className="asset-icon"
                    title="Asset/Inventory Management"
           /> */}
      <span className="Asset">Asset/Inventory Management</span>
                          {renderPinButton("/assetinventory")}

    </li>
    )}
  </ul>
)}

 {!searchTerm && (
    <li
  className="heading privacy-countainer"
  onClick={(e) => {
    e.stopPropagation();
    
    if (isCollapsed) {
      onToggle(); // Sidebar expand karo
      toggleSection("Privacy/DataProtectioncompliance"); // Submenu open karo
    } else {
      toggleSection("Privacy/DataProtectioncompliance"); // Normal toggle
    }
  }}
>
  <img
    src={privacylight}
    alt="Privacy/Data Protection Compliance"
    className="privacy-icon"
    title="Privacy/Data Protection"
  />

  <span className="Privacy-Data-Protection">Privacy/Data Protection </span>
  {/* <span className="Privacy-Data-Protection1">Protection</span> */}

  <img
    src={
      openSection === "Privacy/DataProtectioncompliance"
        ? chevdown
        : chevronright
    }
    alt="Chevron Up"
    className="chevron-icon-privacy"
  />
</li>





  )}
  {openSection === "Privacy/DataProtectioncompliance" &&   !isCollapsed &&
(

                <ul className="sub-menu">

  {!searchTerm && (

                   <li
                    className={isActive("/dpdpmodule") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/dpdpmodule")}
                  >
                    
                   <span style={{ color: "white" }}>India DPDP Act</span> 
                         {renderPinButton("/dpdpmodule")}

                   
                  </li>
  )}
  {!searchTerm && (
  <li
    className={isActive("/consent-management") ? "active" : ""}
    onClick={() => handleSubmenuClick("/consent-management")}
  >
    <span style={{ color: "white" }}>Consent Management</span>
    {renderPinButton("/consent-management")}
  </li>
)}
    {!searchTerm && (

                  <li
                    className={isActive("/ccpamodule") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/ccpamodule")}
                  >
                    
                   <span style={{ color: "white" }}>CCPA</span> 
                    {renderPinButton("/ccpamodule")}

                   
                  </li>
    )}
     
      {!searchTerm && (

                  <li
                    className={isActive("/gdpr") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/gdpr")}
                  >
                    
                   <span style={{ color: "white" }}>GDPR</span> 
                   {renderPinButton("/gdpr")}

                  </li>
      )}
       {!searchTerm && (

                  <li
                    className={isActive("/uaemodule") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/uaemodule")}
                  >
                    
                   <span style={{ color: "white" }}>UAE Data Protection Module</span> 
                                      {renderPinButton("/uaemodule")}

                  </li>
      )}
        {!searchTerm && (


                   <li
                    className={isActive("/pdpl") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/pdpl")}
                  >
                    
                   <span style={{ color: "white" }}>UAE PDPL</span>
                      {renderPinButton("/pdpl")}
 
                   
                  </li>
        )}
          {!searchTerm && (


                  
                  <li
                    className={isActive("/data&riskmgmt") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/data&riskmgmt")}
                  >
                    
                    {/* IAM Text */}
                    <span style={{ color: "white" }}> Data Governance and Risk Management</span>
                        

                    {/* Progress Indicator and Icon */}
                    {/* {moduleProgress?.DataAndRiskMgmt ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.DataAndRiskMgmt.completed}/
                          {moduleProgress.DataAndRiskMgmt.total})
                        </span>
                      </>
                    ) : null} */}
                    {renderPinButton("/data&riskmgmt")}
                  </li>
          )}
            {!searchTerm && (

                  <li
                    className={isActive("/legalCompliance") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/legalCompliance")}
                  >
                     <span style={{ color: "white" }}>Legal and Regulatory Compliance</span>
                                             {renderPinButton("/legalCompliance")}


                    {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.LegalCompliance ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.LegalCompliance.completed}/
                        {moduleProgress.LegalCompliance.total})
                      </span>
                    </>
                  ) : null} */}
                  </li>
            )}
              {!searchTerm && (

                  <li
                    className={
                      isActive("/privacyengineering") ? "active" : ""
                    }
                    onClick={() =>
                      handleSubmenuClick("/privacyengineering")
                    }
                  >
                    <span style={{ color: "white" }}>Privacy by Design and Engineering</span>
                                                                 {renderPinButton("/privacyengineering")}


                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.PrivacyEngineering ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.PrivacyEngineering.completed}/
                        {moduleProgress.PrivacyEngineering.total})
                      </span>
                     
                    </>
                  ) : null} */}
                  </li>
              )}
                {!searchTerm && (

                  <li
                    className={isActive("/privacymaturity") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/privacymaturity")}
                  >
                     <span style={{ color: "white" }}>Privacy Program Framework</span>
                          {renderPinButton("/privacymaturity")}


                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.PrivacyFramework ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.PrivacyFramework.completed}/
                        {moduleProgress.PrivacyFramework.total})
                      </span>
                     
                    </>
                  ) : null} */}
                  </li>
                )}
               
                   {!searchTerm && (

                  <li
                    className={isActive("/nistprivacyframework") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/nistprivacyframework")}
                  >
                  
 
                  {/* <span style={{ marginLeft: "5px" ,color:"white"}}> PCI-DSS(0/50)</span> */}
                  <span className="NISTP1">NIST Privacy Framework</span>
                           {renderPinButton("/nistprivacyframework")}

                    {/* Progress Indicator and Icon */}
                    {/* {moduleProgress?.NISTPrivacyFramework ? (
                    <>
                      <span className="progress-indicator-heading">
                        ({moduleProgress.NISTPrivacyFramework.completed}/
                        {moduleProgress.NISTPrivacyFramework.total})
                      </span>
                     
                    </>
                  ) : null} */}
                  </li>
                 )}
                  </ul>
                 )}
             

                {!searchTerm && (

 
           

                <li
  className="heading privacy-countainer"
  onClick={(e) => {
    e.stopPropagation();
    if (isCollapsed) {
      onToggle(); // Sidebar expand karo
      toggleSection("SupplyChainRisk"); // Submenu open karo
    } else {
      toggleSection("SupplyChainRisk"); // Normal toggle
    }
  }}
>
  <img
    src={SupplyChain}
    alt="Supply Chain Risk"
    className="privacy-icon"
    title="Supply Chain Risk"
  />

  <span className="Privacy-Data-Protection">Supply Chain Risk</span>

  <img
    src={openSection === "SupplyChainRisk" ? chevdown : chevronright}
    alt="Chevron Up"
    className="chevron-icon-privacy"
  />
</li>

                 )}
                {openSection === "SupplyChainRisk" && !isCollapsed && (
                <ul className="sub-menu">
                {!searchTerm && (

                   <li
                    className={isActive("/nist") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/nist")}
                  >
                   
                   <span className="SupplyChainRisk">NIST SP 800-161</span>
                          {renderPinButton("/nist")}

                   
                  </li>
                                   )}
                  {!searchTerm && (

                   <li
                    className={isActive("/ncsc") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/ncsc")}
                  >
                   
                   <span className="SupplyChainRisk">NCSC Supply Chain Guidelines</span>
                                             {renderPinButton("/ncsc")}

                   
                  </li>
                  )}
                {!searchTerm && (

                                   <li
                    className={isActive("/certin") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/certin")}
                  >
                   
                   <span className="SupplyChainRisk">Cert-IN</span>
                      {renderPinButton("/certin")}

                   
                  </li>
                  
                )}
                                {!searchTerm && (

                 <li
                    className={isActive("/nis2") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/nis2")}
                  >
                   
                   <span style={{ color: "white" }}>NIS2</span>
                                         {renderPinButton("/nis2")}

                   
                  </li>
                                )}
                </ul>
                 )}

    {(!searchTerm || "regional compliances".toLowerCase().includes(searchTerm.toLowerCase())) && (
<>
<li
className={`heading resilience-heading location-countainer ${
    openSection === "CyberOperationalResilience" ? "active" : ""
  }`}  onClick={(e) => {
    e.stopPropagation();
    if (isCollapsed) {
      onToggle(); // Sidebar expand karo
      toggleSection("CyberOperationalResilience"); // Submenu bhi open karo
    } else {
      toggleSection("CyberOperationalResilience"); // Normal toggle
    }
  }}
>
<img
    src={locationlight}
    alt="Cyber Operational Resilience"
    className="dashboard-icon-location"
    title="Regional Compliances"
  />
  <span className="Regional">Regional Compliances </span>
  {/* <span className="Regional1">Compliances</span> */}
<img
src={
    openSection === "CyberOperationalResilience" ? chevdown : chevronright
}
  alt="Chevron Up"
  className="chevron-icon-location"
   />
</li>


    {openSection === "CyberOperationalResilience" && !isCollapsed && (
      <ul className="sub-menu resilience-submenu1">
       {[
  { name: "EU", flag: eu },
  { name: "India", flag: india },
  { name: "Ireland", flag: ireland },
  { name: "UK", flag: uk },
  { name: "USA", flag: usa },
].map(({ name, flag }) => (
  <li
    key={name}
    className="resilience-menu-item"
    onClick={(e) => {
      e.stopPropagation();
      toggleResilienceSection(`resilience-${name.toLowerCase()}`);
    }}
  >
    <img src={flag} alt={`${name} Flag`} className="country-flag-icon" />
    <span className="country-name">{name}</span>

    <img
      src={
        openResilienceSections[`resilience-${name.toLowerCase()}`]
          ? chevronup
          : chevrondown
      }
      alt="Chevron Icon"
      className="chevron-icon-resilience-dropdown-icon"
    />

    {openResilienceSections[`resilience-${name.toLowerCase()}`] &&
      renderLaws(laws[name.toLowerCase()] || [], name)}
  </li>
))}

      </ul>
    )}
  </>
)}


{/* ===== Compliances (Parent) ===== */}

{!searchTerm && (
  <li
    className="heading iso-container"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("compliances");
      } else {
        toggleSection("compliances");
      }
    }}
  >
    <img src={compliance} alt="Compliances" className="Compliancesicon" title="Compliances" />
    <span className="Compliances">Compliances</span>
    <img
      src={openSection === "compliances" ? chevdown : chevronright}
      alt=""
      className="chevron-icon-iso"
    />
  </li>
)} 


{/* ===== Compliances → Children ===== */}
{openSection === "compliances" && !isCollapsed &&  (
  <ul className="sub-menu">

    {/* CIS */}
    {!searchTerm && (

    <li
      className={isActive("/cissecurity") ? "active" : ""}
  onClick={(e) => { e.stopPropagation(); handleSubmenuClick("/cissecurity"); }}
    >
      {/* <img src={cislight} alt="CIS" className="asset-icon" /> */}
      <span className="CIS-Security">CIS</span>
                                {renderPinButton("/cissecurity")}

    </li>
    )}
   
{/* ISO27001 (parent inside Compliances) */}
{!searchTerm && (
  <li
    className="iso-container"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("compliances");
        toggleISOSection("iso27001");
      } else {
        toggleISOSection("iso27001");
      }
    }}
  >
    <span className="ISO27001">ISO27001</span>
    <img
      src={openISOSection === "iso27001" ? chevronup : chevrondown}
      alt="Chevron"
      className="chevron-icon-iso"
    />
  </li>
)}

{/* ISO27001 → Submodules */}


{openISOSection === "iso27001" && !isCollapsed &&  (
  
  <ul className="sub-sub-menu1">
    {!searchTerm &&  (

    <li
      className={isActive("/annexacontrolsoverview") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();          
        handleSubmenuClick("/annexacontrolsoverview");
      }}
    >
      <span className="text-white ms-2">Annex A Controls Overview</span>
      {renderPinButton("/annexacontrolsoverview")}
    </li>
    )}
    {!searchTerm && (

    <li
      className={isActive("/organizational") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();         
        handleSubmenuClick("/organizational");
      }}
    >
      <span className="text-white ms-2">Organizational</span>
      {renderPinButton("/organizational")}
    </li>
    )}
    {!searchTerm && (

    <li
      className={isActive("/people") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();          
        handleSubmenuClick("/people");
      }}
    >
      <span className="text-white ms-2">People</span>
      {renderPinButton("/people")}
    </li>
    )}
    {!searchTerm && (


    <li
      className={isActive("/physical") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();       
        handleSubmenuClick("/physical");
      }}
    >
      <span className="text-white ms-2">Physical</span>
       {renderPinButton("/physical")}
    </li>
    )}
    {!searchTerm && (

    <li
      className={isActive("/technological") ? "active" : ""}
      onClick={(e) => {
        handleSubmenuClick("/technological");
      }}
    >
      <span className="text-white ms-2">Technological</span>
       {renderPinButton("/technological")}
    </li>
    )}
  </ul>
)}


    {/* बाकी Compliances के items */}
    {!searchTerm && (

    <li
      className={isActive("/soc2") ? "active" : ""}
      onClick={() => handleSubmenuClick("/soc2")}
    >
      <span className="soc2">SOC2</span>
       {renderPinButton("/soc2")}
    </li>
    )}
    {!searchTerm && (

    <li
      className={isActive("/nistsp80053") ? "active" : ""}
      onClick={() => handleSubmenuClick("/nistsp80053")}
    >
      {/* <img src={NISTSP53} alt="NIST SP 800-53" className="asset-icon" /> */}
      <span className="NISTP">NIST SP 800-53</span>
      {renderPinButton("/nistsp80053")}
    </li>
    )}
    {!searchTerm && (

    <li
      className={isActive("/nistsp80063iam") ? "active" : ""}
      onClick={() => handleSubmenuClick("/nistsp80063iam")}
    >
      {/* <img src={NISTSP63} alt="NIST SP 800-63 (IAM)" className="asset-icon" /> */}
      <span className="NISTP">NIST SP 800-63 (IAM)</span>
      {renderPinButton("/nistsp80063iam")}
    </li>
    )}
    {!searchTerm && (

    <li
      className={isActive("/pcidsscompliance") ? "active" : ""}
      onClick={() => handleSubmenuClick("/pcidsscompliance")}
    >
      {/* <img src={PCILight} alt="PCI-DSS" className="asset-icon" /> */}
      <span className="PCI-DSS">PCI-DSS</span>
        {renderPinButton("/pcidsscompliance")}
    </li>
    )}
    {!searchTerm && (

    <li
      className={isActive("/otiotsecurity") ? "active" : ""}
      onClick={() =>  handleSubmenuClick("/otiotsecurity")}
    >
      {/* <img src={OTIOT} alt="OT/IoT Security" className="asset-icon" /> */}
      <span className="OT-IoT-Security">OT/IoT Security</span>
        {renderPinButton("/otiotsecurity")}
    </li>
    )}


    {!searchTerm &&   (
 <li
      className={isActive("/red") ? "active" : ""}
      onClick={() => handleSubmenuClick("/red")}
    >
      {/* <img src={red} alt="RED" className="asset-icon" /> */}
      <span className="red">RED</span>
      {renderPinButton("/red")}
    </li>
    )}


    {!searchTerm && (

    <li
      className={isActive("/operationalresilience") ? "active" : ""}
      onClick={() => handleSubmenuClick("/operationalresilience")}
    >
      <span className="Operational-Resilience">Operational Resilience</span>
      {renderPinButton("/operationalresilience")}
      
    </li>
    )}

{!searchTerm && (
 
    <li
      className={isActive("/mitre") ? "active" : ""}
      onClick={() => handleSubmenuClick("/mitre")}
    >
      <span style={{color:"white"}}>MITRE</span>
      {renderPinButton("/mitre")}
     
    </li>
    )}
    {!searchTerm && (
 
    <li
      className={isActive("/owasp") ? "active" : ""}
      onClick={() => handleSubmenuClick("/owasp")}
    >
      <span style={{color:"white"}}>OWASP</span>
      {renderPinButton("/owasp")}
     
    </li>
    )}
    {!searchTerm && (
 
    <li
      className={isActive("/cobit") ? "active" : ""}
      onClick={() => handleSubmenuClick("/cobit")}
    >
      <span style={{color:"white"}}>COBIT</span>
      {renderPinButton("/cobit")}
     
    </li>
    )}

  </ul>
)}























{!searchTerm && (
  <li
    className="heading iso-container"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("cloudsecurity");
      } else {
        toggleSection("cloudsecurity");
      }
    }}
  >
    <img
    src={google}
    alt="AWS Cloud Security"
    className="dashboard-icon"
    title="Cloud Security"
  />
    <span className="Compliances1">Cloud Security</span>
    <img
      src={openSection === "cloudsecurity" ? chevdown : chevronright}
      alt=""
      className="chevron-icon-iso"
    />
  </li>
)}

{/* ===== Compliances → Children ===== */}
{openSection === "cloudsecurity" && !isCollapsed && (
  <ul className="sub-menu">

   
{/* AWS(parent inside Compliances) */}
{!searchTerm && (
  <li
    className="iso-container"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("cloudsecurity");
        toggleISOSection("aws");
      } else {
        toggleISOSection("aws");
      }
    }}
  >
<img
    src={AWSLight}
    alt="AWS Cloud Security"
    className="dashboard-icon-aws"
    title="AWS Cloud"
  />
  <span className="AWS-Cloud-Security">AWS Cloud </span>
    <img
      src={openISOSection === "aws" ? chevronup : chevrondown}
      alt="Chevron"
      className="chevron-icon-aws"
    />
  </li>
)}


{/* AWS → Submodules */}
{openISOSection === "aws" && !isCollapsed && (
  <ul className="sub-sub-menu1">
    {!searchTerm && (

    <li
      className={isActive("/iam") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();          
        handleSubmenuClick("/iam");
      }}
    >
       
      <span className="text-white">IAM</span>
      {renderPinButton( "/iam")}

       {/* {moduleProgress?.iam ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.iam.completed}/
                          {moduleProgress.iam.total})
                        </span>
                      </>
                    ) : null} */}
    </li>
    )}
    {!searchTerm && (


 <li
      className={isActive("/detection") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();          
        handleSubmenuClick("/detection");
      }}
    >
      <span className="text-white">Detection</span>
            {renderPinButton( "/detection")}

       {/* {moduleProgress?.detection ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.detection.completed}/
                          {moduleProgress.detection.total})
                        </span>
                      </>
                    ) : null} */}
    </li>
    )}
    {!searchTerm && (

    <li
      className={isActive("/infrastructure_protection") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();          
        handleSubmenuClick("/infrastructure_protection");
      }}
    >
      <span className="text-white">Infrastructure Protection</span>
    {renderPinButton( "/infrastructure_protection")}

       {/* {moduleProgress?.AWSInfrastructureProtection ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.AWSInfrastructureProtection.completed}/
                          {moduleProgress.AWSInfrastructureProtection.total})
                        </span>
                      </>
                    ) : null} */}
    </li>)}
    {!searchTerm && (


    <li
      className={isActive("/dataprotection") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();         
        handleSubmenuClick("/dataprotection");
      }}
    >
      <span className="text-white">Data Protection</span>
                        {renderPinButton( "/dataprotection")}

       {/* {moduleProgress?.dataprotection? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.dataprotection.completed}/
                          {moduleProgress.dataprotection.total})
                        </span>
                      </>
                    ) : null} */}
    </li>
    )}
    {!searchTerm && (

    <li
      className={isActive("/inscidentresponseandautomation") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();         
        handleSubmenuClick("/inscidentresponseandautomation");
      }}
    >
      <span className="text-white">Incident Response & Automation</span>
                              {renderPinButton( "/inscidentresponseandautomation")}

       {/* {moduleProgress?.AWSIRAutomation ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.AWSIRAutomation.completed}/
                          {moduleProgress.AWSIRAutomation.total})
                        </span>
                      </>
                    ) : null} */}
    </li>
    )}
  </ul>
)}


{/* Azure/Entra cloud */}

{!searchTerm && (
  <li
    className="iso-container"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("cloudsecurity");
        toggleISOSection("azure");
      } else {
        toggleISOSection("azure");
      }
    }}
  >
  <img
    src={AzureLight}
    alt="Azure Entra Cloud Security"
    className="dashboard-icon-azure"
    title="Azure Entra Cloud"
  />

  <span className="Azure-Entra-Cloud">Azure/Entra Cloud</span>

      <img
    src={openISOSection === "azure" ? chevronup : chevrondown}
    alt="Chevron Up"
    className="chevron-icon-Azure"
    id="cheron-icon-mob1"
  />
  </li>
)}

{/* azure → Submodules */}
{openISOSection === "azure" &&  !isCollapsed &&(
  <ul className="sub-sub-menu1">
    {!searchTerm && (

    <li
      className={isActive("/iamazurecloudsecurity") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();         
        handleSubmenuClick("/iamazurecloudsecurity");
      }}
    >
      <span className="text-white">IAM</span>
            {renderPinButton( "/iamazurecloudsecurity")}

       {/* {moduleProgress?.EntraAzureIAM ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.EntraAzureIAM.completed}/
                          {moduleProgress.EntraAzureIAM.total})
                        </span>
                      </>
                    ) : null} */}
    </li>
    )}
    {!searchTerm && (


 <li
      className={isActive("/detectionazure") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();          
        handleSubmenuClick("/detectionazure");
      }}
    >
      <span className="text-white">Detection</span>
                  {renderPinButton( "/detectionazure")}

       {/* {moduleProgress?.EntraAzureDetection ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.EntraAzureDetection.completed}/
                          {moduleProgress.EntraAzureDetection.total})
                        </span>
                      </>
                    ) : null} */}
    </li>
    )}
    {!searchTerm && (

<li
      className={isActive("/infrastructureprotectionazure") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();          
        handleSubmenuClick("/infrastructureprotectionazure");
      }}
    >
      <span className="text-white">Infrastructure Protection</span>
                        {renderPinButton( "/infrastructureprotectionazure")}

       {/* {moduleProgress?.AzureInfraProtection ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.AzureInfraProtection.completed}/
                          {moduleProgress.AzureInfraProtection.total})
                        </span>
                      </>
                    ) : null} */}
    </li>
    )}
    {!searchTerm && (


<li
      className={isActive("/dataprotectionazure") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();          
        handleSubmenuClick("/dataprotectionazure");
      }}
    >
      <span className="text-white">Data Protection</span>
                              {renderPinButton( "/dataprotectionazure")}

       {/* {moduleProgress?.AzureDataProtection ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.AzureDataProtection.completed}/
                          {moduleProgress.AzureDataProtection.total})
                        </span>
                      </>
                    ) : null} */}
    </li>
    )}
    {!searchTerm && (


<li
      className={isActive("/aiazure") ? "active" : ""}
      onClick={(e) => {
        e.stopPropagation();         
        handleSubmenuClick("/aiazure");
      }}
    >
      <span className="text-white">Incident Response & Automation</span>
                                    {renderPinButton( "/aiazure")}

       {/* {moduleProgress?.EntraAzureAutomation ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.EntraAzureAutomation.completed}/
                          {moduleProgress.EntraAzureAutomation.total})
                        </span>
                      </>
                    ) : null} */}
    </li>
    )}

  </ul>
)}











{/* M365 Module */}

{!searchTerm && (
  <li
    className="iso-container"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("cloudsecurity");
        toggleISOSection("M365");
      } else {
        toggleISOSection("M365");
      }
    }}
  >
   <img
    src={mlight}
    alt="M365"
    className="dashboard-icon-m365"
    title="M365"
  />

  <span className="M365">M365</span>
      <img
    src={openISOSection === "M365" ? chevronup : chevrondown}
   alt="Chevron Up"
    className="chevron-icon-m365"
  />
  </li>
)}

{/* m365 → Submodules */}
 {openISOSection === "M365" && !isCollapsed && (
                  <ul className="sub-sub-menu1">
                    {!searchTerm && (
                    <li
                      className={isActive("/iamandmfa") ? "active" : ""}
                      onClick={() => handleSubmenuClick("/iamandmfa")}
                    >
                      <span style={{ color: "white" }}> IAM and MFA{" "}</span>
                                              {renderPinButton( "/iamandmfa")}

                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.M365IAMMFA ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.M365IAMMFA.completed}/
                        {moduleProgress.M365IAMMFA.total})
                      </span>
                      
                    </>
                  ) : null} */}
                    </li>
                    )}
 {!searchTerm && (

                    <li
                      className={
                        isActive("/useradministration") ? "active" : ""
                      }
                      onClick={() => handleSubmenuClick("/useradministration")}
                    >
                       <span style={{ color: "white" }}>User Administration{" "}</span>
                       {renderPinButton( "/useradministration")}
                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.UserAdministration ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.UserAdministration.completed}/
                        {moduleProgress.UserAdministration.total})
                      </span>
                     
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={
                        isActive("/intunesuserenrollmentandmanagement")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        handleSubmenuClick(
                          "/intunesuserenrollmentandmanagement"
                        )
                      }
                    >
                      <span style={{ color: "white" }}>Microsoft InTunes User Enrollment And Management{" "}</span>
                                             {renderPinButton( "/intunesuserenrollmentandmanagement")}

                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.IntuneEnrollment ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.IntuneEnrollment.completed}/
                        {moduleProgress.IntuneEnrollment.total})
                      </span>
                    
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={isActive("/grouppolicies") ? "active" : ""}
                      onClick={() => handleSubmenuClick("/grouppolicies")}
                    >
                       <span style={{ color: "white" }}>Group Policies</span>
                          {renderPinButton( "/grouppolicies")}

                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.GroupPolicies ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.GroupPolicies.completed}/
                        {moduleProgress.GroupPolicies.total})
                      </span>
                     
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={isActive("/hybridconnect") ? "active" : ""}
                      onClick={() => handleSubmenuClick("/hybridconnect")}
                    >
                      <span style={{ color: "white" }}> Hybrid Connect</span>
                       {renderPinButton( "/hybridconnect")}
                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.HybridConnect ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.HybridConnect.completed}/
                        {moduleProgress.HybridConnect.total})
                      </span>
                     
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={
                        isActive("/onpremtocloudmigration") ? "active" : ""
                      }
                      onClick={() =>
                        handleSubmenuClick("/onpremtocloudmigration")
                      }
                    >
                      <span style={{ color: "white" }}> On-Premises To Cloud Migration{" "}</span>
                      {renderPinButton( "/onpremtocloudmigration")}
                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.CloudMigration ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.CloudMigration.completed}/
                        {moduleProgress.CloudMigration.total})
                      </span>
                     
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={
                        isActive("/windowsuserbitlockerencryption")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        handleSubmenuClick("/windowsuserbitlockerencryption")
                      }
                    >
                      <span style={{ color: "white" }}>Windows User Bit Locker Encryption{" "}</span>
                      {renderPinButton( "/windowsuserbitlockerencryption")}
                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.BitLockerEncryption ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.BitLockerEncryption.completed}/
                        {moduleProgress.BitLockerEncryption.total})
                      </span>
                     
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={
                        isActive("/windowsuserfirewallmanagement")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        handleSubmenuClick("/windowsuserfirewallmanagement")
                      }
                    >
                       <span style={{ color: "white" }}>Windows User Firewall Management{" "}</span>
                                             {renderPinButton( "/windowsuserfirewallmanagement")}

                      {/* Progress Indicator and Icon
                  {moduleProgress?.FirewallManagement ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.FirewallManagement.completed}/
                        {moduleProgress.FirewallManagement.total})
                      </span>
                      
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={
                        isActive("/windowsuserpatching") ? "active" : ""
                      }
                      onClick={() => handleSubmenuClick("/windowsuserpatching")}
                    >
                       <span style={{ color: "white" }}>Windows User Patching</span>
                         {renderPinButton( "/windowsuserpatching")}
                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.WindowsUserPatching ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.WindowsUserPatching.completed}/
                        {moduleProgress.WindowsUserPatching.total})
                      </span>
                     
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={
                        isActive("/ssoandenterpriseapplications")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        handleSubmenuClick("/ssoandenterpriseapplications")
                      }
                    >
                       <span style={{ color: "white" }}>SSO and Enterprise applications{" "}</span>
                                                {renderPinButton( "/ssoandenterpriseapplications")}

                      {/* Progress Indicator and Icon
                  {moduleProgress?.SSOEntApp ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.SSOEntApp.completed}/
                        {moduleProgress.SSOEntApp.total})
                      </span>
                     
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={isActive("/sentinel") ? "active" : ""}
                      onClick={() => handleSubmenuClick("/sentinel")}
                    >
                       <span style={{ color: "white" }}>Sentinel{" "}</span>
                         {renderPinButton( "/sentinel")}
                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.Sentinel ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.Sentinel.completed}/
                        {moduleProgress.Sentinel.total})
                      </span>
                     
                    </>
                  ) : null} */}
                    </li>
                    )}
  </ul>
)}



{/* google cloud Module */}

{!searchTerm && (
  <li
    className="iso-container"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("cloudsecurity");
        toggleISOSection("google");
      } else {
        toggleISOSection("google");
      }
    }}
  >
  <img
    src={CloudLight}
    alt="Google Cloud"
    className="dashboard-icon-cloud"
    title="Google Cloud"
  />
  <span id="cheron-heading-mob2" className="Google-Cloud-Security">
    Google Cloud
  </span> 

  <img
    src={openISOSection === "google" ? chevronup : chevrondown}
  alt="Chevron Up"
    className="chevron-icon-cloud"
    id="cheron-icon-mob2"
  />
  </li>
)}

{openISOSection === "google" &&  !isCollapsed &&(
                  <ul className="sub-sub-menu1">
                    {!searchTerm && (

                    <li
                      className={isActive("/iamgoogle") ? "active" : ""}
                      onClick={() => handleSubmenuClick("/iamgoogle")}
                    >
                       <span style={{ color: "white" }}>IAM</span>
                       {renderPinButton( "/iamgoogle")}

                      {/* Progress Indicator and Icon
                  {moduleProgress?.GoogleCloudIAM ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.GoogleCloudIAM.completed}/
                        {moduleProgress.GoogleCloudIAM.total})
                      </span>
                      
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={isActive("/detectiongoogle") ? "active" : ""}
                      onClick={() => handleSubmenuClick("/detectiongoogle")}
                    >
                      <span style={{ color: "white" }}> Detection</span>
                                                                     {renderPinButton( "/detectiongoogle")}

                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.GoogleCloudDetection ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.GoogleCloudDetection.completed}/
                        {moduleProgress.GoogleCloudDetection.total})
                      </span>
                     
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={
                        isActive("/infrastructureprotectiongoogle")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        handleSubmenuClick("/infrastructureprotectiongoogle")
                      }
                    >
                       <span style={{ color: "white" }}>Infrastructure Protection</span>
                      {renderPinButton( "/infrastructureprotectiongoogle")}

                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.GoogleInfraProtection ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.GoogleInfraProtection.completed}/
                        {moduleProgress.GoogleInfraProtection.total})
                      </span>
                    
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={
                        isActive("/dataProtectionGoogle") ? "active" : ""
                      }
                      onClick={() =>
                        handleSubmenuClick("/dataProtectionGoogle")
                      }
                    >
                       <span style={{ color: "white" }}>Data Protection</span>
                        {renderPinButton( "/dataProtectionGoogle")}

                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.GoogleDataProtection ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.GoogleDataProtection.completed}/
                        {moduleProgress.GoogleDataProtection.total})
                      </span>
                    
                    </>
                  ) : null} */}
                    </li>
                    )}
                    {!searchTerm && (

                    <li
                      className={isActive("/aiGoogle") ? "active" : ""}
                      to="/aiGoogle"
                      onClick={() => handleSubmenuClick("/aiGoogle")}
                    >
                       <span style={{ color: "white" }}>Incident Response & Automation</span>
                                               {renderPinButton( "/aiGoogle")}

                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.GoogleIRAutomation ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.GoogleIRAutomation.completed}/
                        {moduleProgress.GoogleIRAutomation.total})
                      </span>
                     
                    </>
                  ) : null} */}
                    </li>
                    )}
                  </ul>
                )}

                {!searchTerm && (
  <li
    className="iso-container"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("cloudsecurity");
        toggleISOSection("oracle");
      } else {
        toggleISOSection("oracle");
      }
    }}
  >
  <img
    src={oraclecloud}
    alt="Oracle Cloud"
    className="dashboard-icon-cloud"
    title="Oracle Cloud"
  />
  <span id="cheron-heading-mob2" className="Google-Cloud-Security">
    Oracle Cloud
  </span>
 
  <img
    src={openISOSection === "oracle" ? chevronup : chevrondown}
  alt="Chevron Up"
    className="chevron-icon-cloud"
    id="cheron-icon-mob2"
  />
  </li>
)}
 
{openISOSection === "oracle" &&  !isCollapsed &&(
                  <ul className="sub-sub-menu1">
                    {!searchTerm && (
 
                    <li
                      className={isActive("/iamoracle") ? "active" : ""}
                      onClick={() => handleSubmenuClick("/iamoracle")}
                    >
                       <span style={{ color: "white" }}>IAM</span>
                       {renderPinButton( "/iamoracle")}
                    </li>
                    )}
                    {!searchTerm && (
 
                    <li
                      className={isActive("/detectionoracle") ? "active" : ""}
                      onClick={() => handleSubmenuClick("/detectionoracle")}
                    >
                      <span style={{ color: "white" }}> Detection</span>
                      {renderPinButton( "/detectionoracle")}
 
                    </li>
                    )}
                    {!searchTerm && (
 
                    <li
                      className={
                        isActive("/infrastructureprotectionoracle")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        handleSubmenuClick("/infrastructureprotectionoracle")
                      }
                    >
                       <span style={{ color: "white" }}>Infrastructure Protection</span>
                      {renderPinButton( "/infrastructureprotectionoracle")}
 
                   
                    </li>
                    )}
                    {!searchTerm && (
 
                    <li
                      className={
                        isActive("/dataprotectionoracle") ? "active" : ""
                      }
                      onClick={() =>
                        handleSubmenuClick("/dataprotectionoracle")
                      }
                    >
                       <span style={{ color: "white" }}>Data Protection</span>
                        {renderPinButton( "/dataprotectionoracle")}
 
                    </li>
                    )}
                    {!searchTerm && (
 
                    <li
                      className={isActive("/incidentresponseoracle") ? "active" : ""}
                      to="/incidentresponseoracle"
                      onClick={() => handleSubmenuClick("/incidentresponseoracle")}
                    >
                       <span style={{ color: "white" }}>Incident Response & Automation</span>
                      {renderPinButton( "/incidentresponseoracle")}
 
                   
                    </li>
                    )}
                  </ul>
                )}

</ul>
)}


 


 {!searchTerm && (

              

                <li
  className="heading aws-countainer"
  onClick={(e) => {
    e.stopPropagation();
    if (isCollapsed) {
      onToggle(); // Sidebar expand karo
      toggleSection("networksecurity"); // Submenu bhi open karo
    } else {
      toggleSection("networksecurity"); // Normal toggle
    }
  }}
>
  <img
    src={network}
    alt="Network Infrastructure"
    className="network-icon"
    title="Network Infrastructure"
  />
  
  <span className="Network-Infrastructure">Network Infrastructure</span>
    {/* <span className="Network-Infrastructure1">Infrastructure</span> */}
  

  <img
    src={openSection === "networksecurity" ? chevdown : chevronright}
    alt="Chevron Up"
    className="chevron-icon-Infrastrucure"
  />
</li>

               )}
                {openSection === "networksecurity" && !isCollapsed &&(
                <ul className="sub-menu">
 {!searchTerm && (

                  <li
                    className={isActive("/networksecurity") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/networksecurity")}
                  >
                   
                   
                    <span style={{ color: "white" }}> Network Security</span>
                     
                    {/* Progress Indicator and Icon */}
                    {/* {moduleProgress?.NetworkSecurity ? (
                      <>
                        <span className="progress-indicator">
                          ({moduleProgress.NetworkSecurity.completed}/
                          {moduleProgress.NetworkSecurity.total})
                        </span>
                      </>
                    ) : null} */}
                    {renderPinButton( "/networksecurity")}
                  </li>
 )}
  {!searchTerm && (

 
                  <li
                    className={isActive("/cisco") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/cisco")}
                  >
                   <span style={{ color: "white" }}>Cisco</span> 
                    {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.Cisco ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.Cisco.completed}/
                        {moduleProgress.Cisco.total})
                      </span>
                    </>
                  ) : null} */}
                                      {renderPinButton( "/cisco")}

                  </li>
  )}
   {!searchTerm && (

 
                  <li
                    className={
                      isActive("/juniper") ? "active" : ""
                    }
                    onClick={() =>
                      handleSubmenuClick("/juniper")
                    }
                  >
                    <span style={{ color: "white" }}>Juniper</span>
                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.Juniper ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.Juniper.completed}/
                        {moduleProgress.Juniper.total})
                      </span>
                     
                    </>
                  ) : null} */}
                  {renderPinButton( "/juniper")}

                  </li>
   )}
    {!searchTerm && (

 
                  <li
                    className={isActive("/fortinet") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/fortinet")}
                  >
                    <span style={{ color: "white" }}>Fortinet</span>
                                         
                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.Fortinet ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.Fortinet.completed}/
                        {moduleProgress.Fortinet.total})
                      </span>
                     
                    </>
                  ) : null} */}
                  {renderPinButton( "/fortinet")}
                  </li>
    )} {!searchTerm && (

                  <li
                    className={
                      isActive("/paloalto")
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleSubmenuClick("/paloalto")
                    }
                  >
                    <span style={{ color: "white" }}>Palo Alto</span>
                    
                      {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.PaloAlto ? (
                    <>
                      <span className="progress-indicator">
                        ({moduleProgress.PaloAlto.completed}/
                        {moduleProgress.PaloAlto.total})
                      </span>
                     
                    </>
                  ) : null} */}
                  {renderPinButton( "/fortinet")}
                  </li>
    )}
     {!searchTerm && (

                   <li
                    className={
                      isActive("/checkpoint")
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleSubmenuClick("/checkpoint")
                    }
                  >
                  <span style={{ color: "white" }}>Checkpoint</span>
                   {/* {moduleProgress?.Checkpoint ? (
                    <>
                      <span className="progress-indicator me-5">
                        ({moduleProgress.Checkpoint.completed}/
                        {moduleProgress.Checkpoint.total})
                      </span>
                     
                    </>
                  ) : null} */}
                  {renderPinButton( "/checkpoint")}
                  </li>
     )}
                </ul>
                 )}
                


{!searchTerm && (
  <li
    className="heading privacy-countainer"
    onClick={(e) => {
      e.stopPropagation();
      if (isCollapsed) {
        onToggle();
        toggleSection("Technology&EmergingRisks");
      } else {
        toggleSection("Technology&EmergingRisks");
      }
    }}
  >
   <img
                    src={tech}
                    alt=" Technical-Risks"
                    className="asset-icon"
                    title="Technical Risks"
                    />
    <span className="Privacy-Data-Protection">Technological Risks</span>
    <img
      src={openSection === "Technology&EmergingRisks" ? chevdown : chevronright}
      alt=""
      className="chevron-icon-privacy"
    />
  </li>
)}

{/* ===== Risk Assessment → children (shown only when parent open) ===== */}
{openSection === "Technology&EmergingRisks" &&  !isCollapsed && (
  <ul className="sub-menu">
    {/* Begin Now */}
    {!searchTerm && (
    <li
      className={isActive("/genai") ? "active" : ""}
      onClick={() => handleSubmenuClick("/genai")}
    >
      {/* <img
                    src={genlight}
                    alt="  Generative AI Risks"
                    className="gen-icon"
                    title="Generative AI Risks"
                    /> */}
                  
                          <span className="Generative-AI">Generative AI Risks</span>
                              
        {/* {moduleProgress?.GenAI ? (
          
                      <>
                        <span className="progress-indicator-heading">
                          ({moduleProgress.GenAI.completed}/
                          {moduleProgress.GenAI.total})
                        </span>
                      </>
                    ) : null} */}
                    {renderPinButton( "/genai")}
    </li>
    )}
   {!searchTerm && (
    <li
      className={isActive("/applicationdatabasesecurity") ? "active" : ""}
      onClick={() => handleSubmenuClick("/applicationdatabasesecurity")}
    >
         {/* <img
                    src={datalight}
                    alt=" Application & Database Security"
                    className="database-icon"
                    title="Application & Database"
                    /> */}
                    <span className="Application-Database">Application & Database</span>
                      {renderPinButton( "/applicationdatabasesecurity")}
    </li>
   )}

 {!searchTerm && (

                  <li
                    className={isActive("/devsecops") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/devsecops")}
                  >
                      {/* <img
                    src={devlight}
                    alt="DevSecOps"
                    className="devsecops-icon"
                    title="DevSecOps"
                    /> */}
                  
                    {/* <span style={{ marginLeft: "4px",color:"white" }}>DevSecOps</span> */}
                    <span  className="DevSecOps">DevSecOps</span>
                   

                    {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.DevSecOps ? (
                    <>
                      <span className="progress-indicator-heading">
                        ({moduleProgress.DevSecOps.completed}/
                        {moduleProgress.DevSecOps.total})
                      </span>
                     
                    </>
                  ) : null} */}
                   {renderPinButton( "/devsecops")}
                  </li>
              )}

                    {!searchTerm && (

                  <li
                    className={isActive("/privatecloudhypervisor") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/privatecloudhypervisor")}
                  >
                    
                      {/* <img
                    src={hypervisor}
                    alt=" Private Cloud/Hypervisor"
                    className="hypervisor"
                    title="Private Cloud/Hypervisor"
                    /> */}
                            <span  className="Private-Cloud-Hypervisor">Private Cloud/Hypervisor</span>
                              
                            {/* <span  className="Private-Cloud-Hypervisor1">Cloud/Hypervisor</span> */}

                    {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.PrivateCloudHypervisor ? (
                    <>
                      <span className="progress-indicator-heading">
                        ({moduleProgress.PrivateCloudHypervisor.completed}/
                        {moduleProgress.PrivateCloudHypervisor.total})
                      </span>
                     
                    </>
                  ) : null} */}
                  {renderPinButton( "/privatecloudhypervisor")}
                  </li>
                    )}
              

               
                 {!searchTerm && (
                  <li
                    className={isActive("/blockchainsecurity") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/blockchainsecurity")}
                  >
                     {/* <img
                    src={blockLight}
                    alt="Blockchain "
                    className="blockchain-icon"
                    title="Blockchain "
                    /> */}
                    {/* <span style={{ marginLeft: "9px",color:"white" }}>Blockchain Security</span> */}
                    <span  className="Blockchain-Security">Blockchain </span>
                    
                    {/* Progress Indicator and Icon */}
                  {/* {moduleProgress?.BlockchainSecurity ? (
                    <>
                      <span className="progress-indicator-heading">
                        ({moduleProgress.BlockchainSecurity.completed}/
                        {moduleProgress.BlockchainSecurity.total})
                      </span>
                     
                    </>
                  ) : null} */}
                  {renderPinButton( "/blockchainsecurity")}
                  </li>
                 )}

             
                 {!searchTerm && (
                  <li
                    className={isActive("/wirelesssecurity") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/wirelesssecurity")}
                  >
                     {/* <img
                    src={wirelessLight}
                    alt="Wireless"
                    className="wireless-icon"
                    title="Wireless"
                    /> */}
                    {/* <span style={{ marginLeft: "3px" ,color:"white"}}>Wireless Security</span> */}
                    <span  className="Wireless-Security">Wireless</span>
                    {renderPinButton( "/wirelesssecurity")}
                  </li>
                 )}
  </ul>
)}

 

           
               



 {!searchTerm && (

                <div className="heading-home api-countainer">
                  <li
                    to="/siemintegration"
                    className={isActive("/siemintegration") ? "active" : ""}
                    onClick={() => handleSubmenuClick("/siemintegration")}
                  >
                     <img
                    src={APILight}
                    alt="API Integration"
                    className="api-icon"
                    title="API Integration"
                    />
                   <span className="API-Integration"> Integration</span>

                  </li>
                </div>
              )}
              
{!searchTerm && (
                    <div
                      className="heading-home api-countainer"
                      title="App Security Scanner"
                    >
                      <li
                        to="/dast-scanner"
                        className={isActive("/dast-scanner") ? "active" : ""}
                        onClick={() => handleSubmenuClick("/dast-scanner")}
                      >
                        <img
                          src={securityscan}
                          alt="App Security Scanner"
                          className="scanicon"
                          title="App Security Scanner"
                        />
                        <span style={{color:"white" , marginLeft:"17px"}}> App Security Scanner </span>
                      </li>
                    </div>
                  )} 
              </ul>
              </div>
              
            
            </nav>

        </Col>

      </Row> 

    </Container>
    
    </>

  );
};

export default Menubar;
